<template>
  <div class="admin-main-container">
    <!-- 顶部导航栏 -->
  <nav class="admin-nav-bar">
  <!-- 左侧：Logo -->
  <div class="nav-left">
    <div class="logo">
      <img src="https://xtsq-oss-hb.oss-cn-beijing.aliyuncs.com/sunrise-images/sunrise-logo.png" width="40" height="40" alt="小晖智能客服"/>
      <span>小晖智能客服 · 企业管理中心</span>
    </div>
  </div>

  <!-- 中间：站内信图标 -->
  <div class="nav-center">
    <div class="message-dropdown" ref="messageDropdownContainer" v-click-outside="closeMessageDropdown">
      <div class="message-trigger" @click.stop="toggleMessageDropdown">
        <el-badge 
          :value="totalUnread" 
          :hidden="totalUnread === 0" 
          :max="99"
          class="message-badge"
        >
          <i class="el-icon-message"></i>
        </el-badge>
      </div>
      
<!-- 站内信下拉菜单 -->
<transition name="el-fade-in">
  <div v-show="messageDropdownVisible" class="message-dropdown-menu">
    <!-- 菜单头部 -->
    <div class="message-menu-header">
      <span class="message-menu-title">消息中心</span>
    </div>
    
    <!-- 消息分类快捷入口 -->
    <div class="message-menu-item" @click="goToInbox">
      <div class="menu-item-icon inbox-icon">
        <i class="el-icon-message"></i>
      </div>
      <div class="menu-item-info">
        <span class="menu-item-label">收件箱</span>
        <span class="menu-item-desc">查看系统通知和消息</span>
      </div>
      <el-badge 
        :value="inboxUnread" 
        :hidden="inboxUnread === 0" 
        :max="99"
        class="menu-item-badge"
      />
    </div>
    
    <div class="message-menu-item" @click="goToBatch">
      <div class="menu-item-icon batch-icon">
        <i class="el-icon-s-promotion"></i>
      </div>
      <div class="menu-item-info">
        <span class="menu-item-label">批量消息</span>
        <span class="menu-item-desc">查看平台群发的消息记录</span>
      </div>
      <el-badge 
        :value="batchmessageUnread" 
        :hidden="batchmessageUnread === 0" 
        :max="99"
        class="menu-item-badge"
      />
    </div>
    
    <div class="message-menu-item" @click="openFeedbackList">
      <div class="menu-item-icon feedback-icon">
        <i class="el-icon-edit-outline"></i>
      </div>
      <div class="menu-item-info">
        <span class="menu-item-label">意见反馈</span>
        <span class="menu-item-desc">查看我的反馈和处理进度</span>
      </div>
      <el-badge 
        :value="feedbackUnread" 
        :hidden="feedbackUnread === 0" 
        :max="99"
        class="menu-item-badge"
      />
    </div>
    
    <!-- 分隔线 -->
    <div class="message-menu-divider"></div>
    
    <!-- 快捷操作 -->
    <!-- div class="message-menu-item" @click="submitFeedback">
      <div class="menu-item-icon suggest-icon">
        <i class="el-icon-chat-line-square"></i>
      </div>
      <div class="menu-item-info">
        <span class="menu-item-label">提交反馈</span>
        <span class="menu-item-desc">提出您的建议或问题</span>
      </div>
    </div -->
  </div>
</transition>
    </div>
  </div>

  <!-- 右侧：用户操作区 -->
  <div class="nav-right">
    <div class="user-actions">
      <span class="welcome-text">欢迎，{{ tenantInfo.tenantName }}</span>
<div class="user-dropdown" ref="dropdownContainer" v-click-outside="closeDropdown">
  <div class="avatar-group" @click="toggleDropdown">
    <img :src="tenantInfo.logoUrl" class="user-avatar" alt="用户头像"/>
    <span class="username">{{ userInfo.displayName || userInfo.username }}</span>
    <i class="el-icon-arrow-down" :class="{ rotated: isDropdownOpen }"></i>
  </div>
  
  <!-- 用户下拉菜单 -->
  <transition name="el-fade-in">
    <div v-show="isDropdownOpen" class="dropdown-menu">
      <div class="menu-item" @click="show_agreement">
        <i class="el-icon-document"></i>
        <span>协议与隐私</span>
      </div>    
      <div class="menu-item" v-if="tenantInfo && userInfo.username===tenantInfo.adminUsername && tenantInfo.status && tenantInfo.status == 'APPROVED'" @click="AccountSettings">
        <i class="el-icon-setting"></i>
        <span>账户设置</span>
      </div>
      <div v-if="loginType==='sms'" class="menu-item" @click="passwordSetting_sms">
        <i class="el-icon-key"></i>
        <span>设置密码</span>
      </div>
      <div  v-if="loginType !=='sms'" class="menu-item" @click="ChangePassword">
        <i class="el-icon-refresh"></i>
        <span>修改密码</span>
      </div>
      <div  v-if="tenantderegistration !=null && tenantderegistration.id>0  && tenantderegistration.status>0" class="menu-item" @click="HandlederegistrationFeedback">
        <i><svg t="1792844329784" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5623" width="16" height="16"><path d="M883.2 83.2l-742.4 0c-51.2 0-92.8 41.6-92.8 89.6l0 582.4c0 48 41.6 89.6 92.8 89.6l256 0c0 0 6.4 6.4 16 19.2 3.2 3.2 6.4 6.4 9.6 12.8 0 0 6.4 9.6 9.6 12.8 28.8 44.8 51.2 67.2 86.4 67.2 35.2 0 60.8-22.4 89.6-67.2 22.4-35.2 28.8-44.8 28.8-44.8l249.6 0c51.2 0 92.8-41.6 92.8-89.6l0-582.4C976 121.6 934.4 83.2 883.2 83.2zM931.2 755.2c0 25.6-19.2 44.8-44.8 44.8l-252.8 0c-6.4 0-9.6 0-16 3.2-9.6 6.4-19.2 12.8-28.8 28.8-3.2 6.4-22.4 35.2-22.4 35.2-19.2 32-35.2 44.8-48 44.8-12.8 0-25.6-12.8-48-44.8-3.2-3.2-6.4-12.8-9.6-12.8-3.2-6.4-6.4-9.6-9.6-12.8-19.2-25.6-32-38.4-54.4-38.4l-256 0c-25.6 0-44.8-19.2-44.8-44.8l0-582.4c0-25.6 22.4-44.8 48-44.8l742.4 0c25.6 0 48 19.2 48 44.8L934.4 755.2z" p-id="5624" fill="#1296db"></path><path d="M220.8 483.2a1.6 1.6 0 1 0 102.4 0 1.6 1.6 0 1 0-102.4 0Z" p-id="5625" fill="#1296db"></path><path d="M460.8 483.2a1.6 1.6 0 1 0 102.4 0 1.6 1.6 0 1 0-102.4 0Z" p-id="5626" fill="#1296db"></path><path d="M697.6 483.2a1.6 1.6 0 1 0 102.4 0 1.6 1.6 0 1 0-102.4 0Z" p-id="5627" fill="#1296db"></path></svg></i>
        <span>租户注销反馈</span>
      </div>
      <div  v-if="tenantderegistration !=null && tenantderegistration.id>0  && tenantderegistration.status==0 && tenantInfo !=null && tenantInfo.status!=null && tenantInfo.status.trim()=='DELETED'" class="menu-item" @click="HandlederegistrationRestoreApply">
        <i><svg t="1793416837871" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5616" width="16" height="16"><path d="M81.06666666666665 573.8826666666666C81.06666666666665 735.8112 198.42026666666666 853.3333333333333 360.14079999999996 853.3333333333333H900.2666666666667c18.88 0 34.13333333333333-15.258666666666667 34.13333333333333-34.13333333333333s-15.258666666666667-34.13333333333333-34.13333333333333-34.13333333333333H360.14079999999996C236.03199999999995 785.0666666666666 149.33333333333334 698.2314666666666 149.33333333333334 573.8826666666666v-6.6197333333333335C149.33333333333334 438.48 239.9584 341.33333333333337 360.14079999999996 341.33333333333337h455.8848L705.8431999999998 451.85386666666665c-13.2768 13.348266666666666-13.347199999999999 34.952533333333335 0.06506666666666666 48.2624a34.13333333333333 34.13333333333333 0 0 0 48.26773333333333-0.06613333333333332l169.504-169.984c0.031999999999999994-0.031999999999999994 0.031999999999999994-0.06506666666666666 0.06399999999999999-0.10346666666666667 0.034133333333333335-0.031999999999999994 0.06613333333333332-0.031999999999999994 0.10453333333333334-0.0704a34.144 34.144 0 0 0-0.2730666666666667-48.26773333333333L752.6357333333333 112.56320000000005a34.13333333333333 34.13333333333333 0 0 0-47.9936 48.53546666666667l113.18613333333332 111.95733333333332H360.14079999999996C201.04746666666662 273.05600000000004 81.06666666666665 399.55626666666666 81.06666666666665 567.2522666666666v6.6304z" p-id="5617" fill="#1296db"></path></svg></i>
        <span style="font-size: small;">申请恢复租户状态</span>
      </div>
            <div class="menu-item"  v-if="userInfo.username===tenantInfo.adminUsername && tenantInfo && tenantInfo.status && tenantInfo.status == 'APPROVED'" @click="deregistrationApply">
        <i><svg t="1792283600779" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6709" width="16" height="16"><path d="M987.52 1003.52a30.72 30.72 0 0 1-21.76-8.32l-277.12-263.68a31.36 31.36 0 0 1 0-44.8 32 32 0 0 1 44.8 0l277.12 263.04a31.36 31.36 0 0 1 0 44.8 32.64 32.64 0 0 1-23.04 8.96z" fill="#1296db" p-id="6710"></path><path d="M717.44 1010.56a31.36 31.36 0 0 1-21.76-8.96 30.72 30.72 0 0 1 0-44.16L960 680.32a32 32 0 1 1 46.08 43.52l-263.04 277.12a32.64 32.64 0 0 1-25.6 9.6zM463.36 554.88a274.56 274.56 0 1 1 273.92-273.92 274.56 274.56 0 0 1-273.92 273.92z m0-485.76a211.84 211.84 0 1 0 211.2 211.84 211.84 211.84 0 0 0-211.2-211.84z" fill="#1296db" p-id="6711"></path><path d="M586.24 1017.6h-576v-70.4a455.04 455.04 0 0 1 453.76-455.04 31.36 31.36 0 1 1 0 64 392.96 392.96 0 0 0-392.32 391.04v7.04h512a32 32 0 0 1 0 64z" fill="#1296db" p-id="6712"></path></svg></i>
        <span>申请注销</span>
      </div>
      <div class="menu-divider"></div>
      <div class="menu-item logout" @click="logoutConfirm">
        <i class="el-icon-switch-button"></i>
        <span>退出登录</span>
      </div>
    </div>
  </transition>
</div>
  </div>
  </div>
</nav>

    <!-- 主内容区 -->
    <div class="admin-main">
      <!-- 侧边栏 -->
      <div class="sidebar" v-show="isDataLoaded">
        <div class="sidebar-header" v-if="tenantInfo">
          <div class="tenant-nickname">
            企业简称: {{ tenantInfo.nickname }}
          </div>
        </div>
        <ul class="sidebar-menu">
          <li
            @click="navigateTo('dashboard')"
            :class="{active: activeMenu === 'dashboard'}">
            <svg t="1761525587015" class="icon" viewBox="0 0 1026 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7593" width="16" height="16"><path d="M21.72096 1011.2h288v-512L226.52096 448 21.72096 614.4v396.8z m352 0h288v-512L520.92096 608 373.72096 537.6v473.6zM725.72096 448v563.2h288V454.4l-121.6-153.6L725.72096 448z" p-id="7594" fill="#1296db"></path><path d="M60.12096 492.8l153.6-128L514.52096 544l352-320 6.4-6.4 57.6 57.6 96-256-268.8 83.2 64 64L508.12096 448 213.72096 281.6 15.32096 435.2c-19.2 12.8-19.2 38.4-6.4 57.6 12.8 12.8 38.4 12.8 51.2 0z" p-id="7595" fill="#1296db"></path></svg>
            <span>数据概览</span>
          </li>
          <li v-if="tenantInfo && tenantInfo.status && tenantInfo.status == 'APPROVED'"
            @click="navigateTo('employees')"
            :class="{active: activeMenu === 'employees'}">
            <svg t="1761525675190" class="icon" viewBox="0 0 1644 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8745" width="24" height="24"><path d="M1085.402905 692.230635c-11.538036-35.986474-38.667669-57.753716-71.032623-73.586747-22.428011-11.004338-46.330043-18.946268-68.897831-29.671051a369.547538 369.547538 0 0 1-52.63276-30.217456c-7.128676-4.968471-13.304321-15.248506-14.511494-23.914739-2.693903-17.713681-1.880649-35.986474-2.020427-53.979711a14.930829 14.930829 0 0 1 3.367378-8.996618c16.786063-17.993237 24.448438-40.141691 30.217456-63.382956a16.442972 16.442972 0 0 1 6.976191-9.403245c18.946268-10.750197 27.803109-47.537217 14.231939-64.577422-4.434774-5.641947-4.434774-10.165671-2.668489-16.252366 9.657387-32.631802 14.092161-65.670232 11.43638-99.776056-3.087822-39.074296-24.982135-65.81001-62.442632-74.654143-3.2276-0.813254-6.175645-3.507156-9.136396-5.222613-8.996618-5.502169-17.319761-14.231939-26.977148-15.97281-18.80649-3.507156-38.40082-5.641947-57.334382-4.155218-70.371854 5.362391-111.199728 43.11515-113.893631 117.629515-0.927617 28.603655 4.040854 56.406764 9.936943 84.197166a19.060632 19.060632 0 0 1-2.833681 13.164543c-13.024765 17.993237-5.362391 54.780257 13.838019 65.81001 2.948044 1.740871 6.175645 5.222613 6.976192 8.323143 5.641947 24.029104 13.838019 46.596892 31.297558 64.996756a11.715935 11.715935 0 0 1 2.83368 8.056294c-0.254142 21.60205-0.953032 43.102443-1.474022 66.737627 4.968471 1.880649 12.35129 4.028147 19.20041 7.128676 18.793783 8.33585 38.540598 15.248506 55.911188 26.189309 19.20041 11.95737 29.671051 30.497012 28.997576 54.780257-0.673476 26.049531 1.067395 52.099061 1.207173 78.161299 0 8.589992 2.414347 11.283894 11.436379 11.283894 77.881743-0.39392 155.776194-0.254142 233.543573-0.127071 4.028147 0 7.916516 0.39392 11.944663 0.673476v-2.020427c-2.261862-10.673954-4.155218-21.284373-7.370111-31.221316z m-273.431123-52.226132c0.673476-25.109206-10.889975-40.281469-30.890931-51.425586a208.103983 208.103983 0 0 0-24.562801-11.029752c-28.197029-11.144116-56.533835-22.034091-84.730864-33.292571-31.297558-12.35129-61.781863-27.396482-94.032452-36.672657-23.101486-6.709343-38.40082-18.120308-47.397439-39.468215-2.020427-4.574552-4.968471-8.72977-6.569565-13.418685-2.693903-8.056294-7.382818-12.097148-16.252366-13.024766-12.35129-1.270709-13.698241-4.574552-8.894961-16.239658a22.237404 22.237404 0 0 1 4.294995-7.802153c13.977797-13.977797 18.399864-30.878224 18.260086-50.078634-0.139778-17.179983 5.387805-31.958327 23.495406-39.391973 4.854108-2.00772 9.682801-7.929223 11.436379-13.164544 11.283894-31.958327 18.526935-64.32328-0.254141-96.408677-1.740871-3.087822-3.367378-6.988898-3.227601-10.330863 0.813254-22.961708 1.474022-45.923417 3.227601-68.758054 2.274569-30.090385 0.673476-59.215031-14.651273-86.4082-5.362391-9.403245-12.884987-14.231939-23.774962-15.845739-7.382818-1.067395-15.718668-4.028147-21.360615-8.894961-27.790402-23.91474-60.282426-30.090385-95.201505-27.955594-31.691478 1.880649-60.994023 13.291614-90.220325 24.575508q-45.338891 17.345175-59.354809 63.255885c-9.263467 30.090385-7.802152 60.689053-3.227601 91.186065 2.833681 18.793783 8.894962 37.333425-4.028146 54.780257a6.645807 6.645807 0 0 0-0.813254 4.828693c3.214893 24.029104 5.769018 48.2234 10.330863 71.985655 2.274569 12.071734 10.470641 20.407584 23.914739 22.567788 2.948044 0.39392 7.103262 5.082835 7.522597 8.196072 2.147498 16.252366 2.274569 32.644509 4.968471 48.74439 1.270709 8.056294 5.781725 15.845739 9.657387 23.368335 2.820974 5.502169 7.624253 10.076721 10.610419 15.57889 3.341964 5.896089 3.087822 11.004338-5.781725 11.677814-6.594979 0.533698-9.936943 4.828693-12.884988 10.73749-5.781725 11.95737-12.35129 23.635184-19.060632 35.17322-5.082835 8.72977-12.605431 13.838019-22.872759 16.252366a231.650217 231.650217 0 0 0-35.185927 11.004338q-81.325364 32.441196-162.358465 65.530454a158.736945 158.736945 0 0 0-28.209736 14.905414c-14.231939 9.682801-21.754535 22.872759-21.60205 41.234501 0.279556 36.3931-1.346951 72.786201-2.274568 109.179302h357.069177c3.481742-24.982135 6.849121-50.091342 10.47064-75.073477 4.828693-32.619095 9.936943-65.136534 14.498788-97.844579 0.406627-3.341964-1.067395-7.103262-2.541418-10.330863-4.688916-10.330863-9.263467-20.68714-14.778343-30.624082-4.155218-7.522596-2.414347-11.538036 5.375098-14.092161a27.853937 27.853937 0 0 0 9.797165-4.828693c28.044544-22.30094 51.425586-7.94193 75.467397 10.16567-5.921503 12.097148-12.630846 24.30866-17.993237 37.206354-2.299983 5.781725-3.62152 13.024765-2.299983 18.946269 12.224219 54.259266 25.121913 108.366048 37.87983 162.472829a35.211341 35.211341 0 0 1 0.419333 3.901076h340.994711c-1.194466-35.122392-3.341964-70.181248-2.40164-105.21469z m0 0" p-id="8746" fill="#1296db"></path></svg>
            <span>团队管理</span>
          </li>
          <li v-if="tenantInfo && tenantInfo.status && tenantInfo.status == 'APPROVED'"
            @click="navigateTo('knowledge')"
            :class="{active: activeMenu === 'knowledge'}">
             <svg t="1761525361363" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5530" width="16" height="16"><path d="M372.363636 744.727273h-76.101818a54.225455 54.225455 0 0 1-50.036363-30.487273 40.727273 40.727273 0 0 1-4.887273-23.272727 151.738182 151.738182 0 0 0-23.272727-82.152728 152.436364 152.436364 0 0 0-20.945455-24.901818 351.883636 351.883636 0 0 1-41.890909-56.087272 302.545455 302.545455 0 0 1-27.927273-54.69091A180.363636 180.363636 0 0 1 116.363636 418.909091a246.923636 246.923636 0 0 1 6.050909-61.44 222.021818 222.021818 0 0 1 38.167273-84.712727A268.8 268.8 0 0 1 261.585455 186.181818a240.174545 240.174545 0 0 1 54.690909-18.385454 286.952727 286.952727 0 0 1 69.818181-5.585455 256 256 0 0 1 93.09091 21.178182 251.810909 251.810909 0 0 1 52.363636 32.349091 281.6 281.6 0 0 1 60.974545 67.723636 229.934545 229.934545 0 0 1 31.185455 76.334546 222.254545 222.254545 0 0 1 4.654545 66.792727 184.32 184.32 0 0 1-13.963636 55.621818 312.32 312.32 0 0 1-44.683636 77.265455 328.145455 328.145455 0 0 1-25.134546 28.858181 114.269091 114.269091 0 0 0-23.272727 34.676364 165.701818 165.701818 0 0 0-14.196364 40.261818c-1.163636 8.610909-1.163636 16.989091-2.094545 25.367273a124.741818 124.741818 0 0 1-2.56 18.385455 51.665455 51.665455 0 0 1-24.901818 29.323636 58.88 58.88 0 0 1-29.323637 7.214545z m-26.996363-512c-7.68 0-15.592727 1.396364-23.272728 2.792727a151.738182 151.738182 0 0 0-52.596363 18.850909 171.752727 171.752727 0 0 0-39.330909 31.418182 165.003636 165.003636 0 0 0-30.72 45.149091A169.658182 169.658182 0 0 0 186.181818 397.963636a19.549091 19.549091 0 1 0 39.098182 2.094546v-9.774546a116.363636 116.363636 0 0 1 7.447273-34.676363 131.956364 131.956364 0 0 1 46.545454-59.578182 118.458182 118.458182 0 0 1 66.792728-24.436364 85.178182 85.178182 0 0 0 13.265454-1.163636 16.523636 16.523636 0 0 0 13.498182-10.938182 25.6 25.6 0 0 0 0-13.265454 16.523636 16.523636 0 0 0-14.894546-13.498182z m-73.541818 581.818182h201.076363a15.127273 15.127273 0 0 1 15.825455 13.730909v42.356363a15.127273 15.127273 0 0 1-15.825455 13.730909h-201.076363a15.127273 15.127273 0 0 1-15.825455-13.730909v-42.356363a15.127273 15.127273 0 0 1 15.825455-13.730909z" fill="#1296db" opacity=".3" p-id="5531"></path><path d="M605.090909 804.538182h-90.298182A63.767273 63.767273 0 0 1 455.447273 768a50.734545 50.734545 0 0 1-5.818182-26.763636 186.181818 186.181818 0 0 0-27.927273-99.374546 181.992727 181.992727 0 0 0-24.669091-30.254545 415.883636 415.883636 0 0 1-49.803636-67.723637 378.181818 378.181818 0 0 1-33.28-66.56 226.443636 226.443636 0 0 1-11.403636-68.421818 298.123636 298.123636 0 0 1 7.214545-74.705454 266.24 266.24 0 0 1 46.545455-101.003637 319.767273 319.767273 0 0 1 119.621818-103.796363 291.374545 291.374545 0 0 1 65.163636-23.272728 331.170909 331.170909 0 0 1 81.687273-6.516363 281.134545 281.134545 0 0 1 170.356363 65.629091 338.850909 338.850909 0 0 1 72.378182 82.152727 279.272727 279.272727 0 0 1 37.003637 93.090909 276.014545 276.014545 0 0 1 5.12 80.058182 235.054545 235.054545 0 0 1-16.523637 67.490909 389.12 389.12 0 0 1-83.083636 128.232727 147.083636 147.083636 0 0 0-27.229091 42.123637 202.24 202.24 0 0 0-16.756364 48.872727c-1.629091 10.24-1.629091 20.48-2.56 30.487273a147.781818 147.781818 0 0 1-3.258181 23.272727 60.043636 60.043636 0 0 1-29.556364 35.374545 66.327273 66.327273 0 0 1-34.443636 9.076364z m-18.618182-626.734546c-9.774545 0-19.549091 1.861818-29.090909 3.490909a192.930909 192.930909 0 0 0-65.396363 23.272728A209.454545 209.454545 0 0 0 442.181818 243.665455a194.327273 194.327273 0 0 0-37.934545 55.854545 211.781818 211.781818 0 0 0-16.756364 82.850909 25.134545 25.134545 0 0 0 8.378182 19.781818 23.272727 23.272727 0 0 0 20.712727 5.818182 25.134545 25.134545 0 0 0 19.549091-23.272727V372.363636a144.523636 144.523636 0 0 1 8.610909-43.054545A164.538182 164.538182 0 0 1 502.458182 256a146.850909 146.850909 0 0 1 82.850909-30.021818l16.756364-1.396364a20.48 20.48 0 0 0 16.523636-13.730909 25.134545 25.134545 0 0 0 0-16.523636 20.48 20.48 0 0 0-18.152727-16.523637zM488.727273 861.090909h232.727272a18.152727 18.152727 0 0 1 18.152728 18.152727v56.32a18.385455 18.385455 0 0 1-18.152728 18.618182H488.727273a18.385455 18.385455 0 0 1-18.152728-18.385454v-56.785455A18.152727 18.152727 0 0 1 488.727273 861.090909z" fill="#1296db" p-id="5532"></path></svg>
            <span>知识库</span>
          </li>          
          <li v-if="tenantInfo && tenantInfo.status && tenantInfo.status == 'APPROVED'"
            @click="navigateTo('imagelibrary')"
            :class="{active: activeMenu === 'imagelibrary'}">
            <svg t="1763975762449" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6712" width="16" height="16"><path d="M113.777778 341.105778l0 512.512C113.777778 884.906667 139.150222 910.222222 170.439111 910.222222l512.512 0C714.24 910.222222 739.555556 884.849778 739.555556 853.560889L739.555556 284.444444 170.439111 284.444444C139.093333 284.444444 113.777778 309.816889 113.777778 341.105778zM296.277333 388.721778c43.178667 0 78.222222 35.043556 78.222222 78.222222S339.512889 545.166222 296.277333 545.166222 218.055111 510.179556 218.055111 466.944 253.098667 388.721778 296.277333 388.721778zM179.143111 802.645333c0 0 21.731556-136.192 91.420444-136.192s61.383111 58.140444 113.777778 58.140444 74.012444-179.427556 144.440889-179.427556c70.428444 0 141.937778 258.389333 141.937778 258.389333 9.216 30.094222-8.476444 54.499556-40.106667 54.499556l-407.893333 0C191.374222 858.055111 171.292444 833.024 179.143111 802.645333z" fill="#1296db" p-id="6713"></path><path d="M170.666667 227.555556c0 15.701333 12.743111 28.444444 28.444444 28.444444l568.888889 0 0 568.888889c0 15.701333 12.743111 28.444444 28.444444 28.444444 15.701333 0 28.444444-12.743111 28.444444-28.444444l0-625.777778-625.777778 0C183.409778 199.111111 170.666667 211.854222 170.666667 227.555556z" fill="#1296db" p-id="6714"></path><path d="M256 113.777778C240.298667 113.777778 227.555556 126.520889 227.555556 142.222222S240.298667 170.666667 256 170.666667L853.333333 170.666667l0 597.333333c0 15.701333 12.743111 28.444444 28.444444 28.444444 15.701333 0 28.444444-12.743111 28.444444-28.444444L910.222222 113.777778 256 113.777778z" fill="#1296db" p-id="6715"></path></svg>
            <span>图片库管理</span>
          </li> 
          <li 
            v-if="userInfo.username === tenantInfo.adminUsername"
            @click="navigateTo('operationlog')"
            :class="{active: activeMenu === 'operationlog'}">
            <svg t="1763975762449" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6712" width="16" height="16"><path d="M113.777778 341.105778l0 512.512C113.777778 884.906667 139.150222 910.222222 170.439111 910.222222l512.512 0C714.24 910.222222 739.555556 884.849778 739.555556 853.560889L739.555556 284.444444 170.439111 284.444444C139.093333 284.444444 113.777778 309.816889 113.777778 341.105778zM296.277333 388.721778c43.178667 0 78.222222 35.043556 78.222222 78.222222S339.512889 545.166222 296.277333 545.166222 218.055111 510.179556 218.055111 466.944 253.098667 388.721778 296.277333 388.721778zM179.143111 802.645333c0 0 21.731556-136.192 91.420444-136.192s61.383111 58.140444 113.777778 58.140444 74.012444-179.427556 144.440889-179.427556c70.428444 0 141.937778 258.389333 141.937778 258.389333 9.216 30.094222-8.476444 54.499556-40.106667 54.499556l-407.893333 0C191.374222 858.055111 171.292444 833.024 179.143111 802.645333z" fill="#1296db" p-id="6713"></path><path d="M170.666667 227.555556c0 15.701333 12.743111 28.444444 28.444444 28.444444l568.888889 0 0 568.888889c0 15.701333 12.743111 28.444444 28.444444 28.444444 15.701333 0 28.444444-12.743111 28.444444-28.444444l0-625.777778-625.777778 0C183.409778 199.111111 170.666667 211.854222 170.666667 227.555556z" fill="#1296db" p-id="6714"></path><path d="M256 113.777778C240.298667 113.777778 227.555556 126.520889 227.555556 142.222222S240.298667 170.666667 256 170.666667L853.333333 170.666667l0 597.333333c0 15.701333 12.743111 28.444444 28.444444 28.444444 15.701333 0 28.444444-12.743111 28.444444-28.444444L910.222222 113.777778 256 113.777778z" fill="#1296db" p-id="6715"></path></svg>
            <span>操作日志</span>
          </li> 
          <li v-if="tenantInfo && tenantInfo.status && tenantInfo.status == 'APPROVED'"
            @click="navigateTo('statisticsCenter')"
            :class="{active: activeMenu === 'statisticsCenter'}">
           <svg t="1766410019180" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5595" width="16" height="16"><path d="M715.1 456.3h184.1v294.6H715.1V456.3zM494.2 198.6h184.1v552.3H494.2V198.6z m-221 184.1h184.1v368.2H273.2V382.7z m626 478.7c0 20.3-16.5 36.8-36.8 36.8H126V161.8c0-20.3 16.5-36.8 36.8-36.8s36.8 16.5 36.8 36.8v662.8h662.8c20.3 0 36.8 16.4 36.8 36.8z" fill="#1296db" p-id="5596"></path></svg>
            <span>统计中心</span>           
          </li>                     
          <li v-if="tenantInfo && tenantInfo.status && tenantInfo.status == 'APPROVED'"
            @click="navigateTo('plan-and-package')"
            :class="{active: activeMenu === 'plan-and-package'}">
            <svg t="1765010534534" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18352" width="16" height="16"><path d="M262.7584 52.1216h502.6816c115.712 0 209.408 93.7984 209.408 209.408v502.6816c0 115.712-93.7984 209.408-209.408 209.408H262.7584c-115.712 0-209.408-93.7984-209.408-209.408V261.5296c0-115.6096 93.7984-209.408 209.408-209.408z m45.568 502.6816c-23.1424 0-41.8816 18.7392-41.8816 41.8816v125.6448c0 23.1424 18.7392 41.8816 41.8816 41.8816h125.6448c23.1424 0 41.8816-18.7392 41.8816-41.8816V596.6848c0-23.1424-18.7392-41.8816-41.8816-41.8816H308.3264z m293.1712 0c-23.1424 0-41.8816 18.7392-41.8816 41.8816v125.6448c0 23.1424 18.7392 41.8816 41.8816 41.8816h125.6448c23.1424 0 41.8816-18.7392 41.8816-41.8816V596.6848c0-23.1424-18.7392-41.8816-41.8816-41.8816H601.4976zM664.3712 471.04c57.856 0 104.7552-46.8992 104.7552-104.7552s-46.8992-104.7552-104.7552-104.7552-104.7552 46.8992-104.7552 104.7552S606.5152 471.04 664.3712 471.04z m-262.144-196.096c-16.384-16.384-42.9056-16.384-59.2896 0l-67.8912 67.8912a41.7792 41.7792 0 0 0 0 59.1872l67.8912 67.8912c16.384 16.384 42.9056 16.384 59.2896 0l67.8912-67.8912a41.7792 41.7792 0 0 0 0-59.1872l-67.8912-67.8912z" fill="#409EFF" p-id="18353"></path></svg>
            <span>套餐与流量包</span>
          </li>
          <li v-if="tenantInfo && tenantInfo.status && tenantInfo.status == 'APPROVED'"
            @click="navigateTo('cart')"
            :class="{active: activeMenu === 'cart'}">
            <svg t="1765704675860" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5627" width="32" height="32"><path d="M455.168 644.096h179.2V609.28H474.624zM542.208 713.728c0 25.6 20.48 46.592 46.08 46.592s46.592-20.992 46.592-46.592c0-4.096-0.512-7.68-1.536-11.776h-89.6c-1.024 3.584-1.536 7.68-1.536 11.776zM355.84 667.136c-25.6 0-46.08 20.992-46.08 46.592s20.48 46.592 46.08 46.592 46.592-20.992 46.592-46.592-20.48-46.592-46.592-46.592zM428.032 597.504H366.08c-3.072 0-5.632-2.56-5.632-5.632 0-1.024 0-2.048 0.512-2.56l20.992-37.888h46.08l-71.68-151.04h-46.592v-46.592h75.776l22.016 46.592h257.536l12.8-23.552c2.048-3.072 3.072-7.168 3.072-11.264 0-12.8-10.24-23.04-23.04-23.04h-343.04l-22.016-46.592H216.576v46.592h46.592l83.456 176.128-31.232 56.832c-3.584 6.656-5.632 14.336-5.632 22.528 0 25.6 20.992 46.592 46.592 46.592H404.48c1.024-3.584 2.56-7.168 4.096-10.752l19.456-36.352z" fill="#AAD4FF" p-id="5628"></path><path d="M680.96 725.504c-25.6 0-46.08 20.992-46.08 46.592s20.48 46.592 46.08 46.592 46.592-20.992 46.592-46.592c0-26.112-20.992-46.592-46.592-46.592zM449.024 725.504c-25.6 0-46.08 20.992-46.08 46.592s20.48 46.592 46.08 46.592 46.592-20.992 46.592-46.592c-0.512-26.112-20.992-46.592-46.592-46.592zM455.168 644.096l18.944-34.816h173.056c17.408 0 32.768-9.728 40.448-24.064l82.944-150.528c2.048-3.072 3.072-7.168 3.072-11.264 0-12.8-10.24-23.04-23.04-23.04h-343.04l-22.016-46.592H309.76v46.592h46.592l71.68 151.04 11.776 25.088-11.776 20.992-19.456 35.84c-2.048 3.584-3.072 7.168-4.096 10.752-1.024 3.584-1.536 7.68-1.536 11.776 0 25.6 20.992 46.592 46.592 46.592h279.04v-46.592H458.752c-3.072 0-5.632-2.56-5.632-5.632 0-1.024 0-2.048 0.512-2.56l1.536-3.584z" fill="#2B95FF" p-id="5629"></path><path d="M223.232 696.32h-29.696v-29.696c0-6.656-5.12-11.776-11.776-11.776s-11.776 5.12-11.776 11.776v29.696h-29.696c-6.656 0-11.776 5.12-11.776 11.776 0 6.656 5.12 11.776 11.776 11.776h29.696v29.696c0 6.656 5.12 11.776 11.776 11.776s11.776-5.12 11.776-11.776v-29.696h29.696c6.656 0 11.776-5.12 11.776-11.776-0.512-6.656-5.632-11.776-11.776-11.776z" fill="#A8D4FF" p-id="5630"></path><path d="M172.032 437.248h65.536v65.536H172.032z" fill="#D9EDFF" p-id="5631"></path><path d="M861.696 655.36m-32.768 0a32.768 32.768 0 1 0 65.536 0 32.768 32.768 0 1 0-65.536 0Z" fill="#D9EDFF" p-id="5632"></path><path d="M825.856 298.496l-89.088-89.088c-3.072-3.072-8.192-4.096-12.8-2.56-4.096 2.048-7.168 6.144-7.168 10.752v89.088c0 3.072 1.536 6.144 3.584 8.192 2.048 2.048 5.12 3.584 8.192 3.584h89.088c4.608 0 8.704-3.072 10.752-7.168 1.536-4.608 0.512-9.728-2.56-12.8z m-86.016-3.584V245.76l49.152 49.152h-49.152z" fill="#A8D4FF" p-id="5633"></path></svg>
            <span>购物车</span>
          </li>          
          <li 
            @click="navigateTo('orders')"
            :class="{active: activeMenu === 'orders'}">
              <svg t="1765704675860" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5627" width="32" height="32"><path d="M455.168 644.096h179.2V609.28H474.624zM542.208 713.728c0 25.6 20.48 46.592 46.08 46.592s46.592-20.992 46.592-46.592c0-4.096-0.512-7.68-1.536-11.776h-89.6c-1.024 3.584-1.536 7.68-1.536 11.776zM355.84 667.136c-25.6 0-46.08 20.992-46.08 46.592s20.48 46.592 46.08 46.592 46.592-20.992 46.592-46.592-20.48-46.592-46.592-46.592zM428.032 597.504H366.08c-3.072 0-5.632-2.56-5.632-5.632 0-1.024 0-2.048 0.512-2.56l20.992-37.888h46.08l-71.68-151.04h-46.592v-46.592h75.776l22.016 46.592h257.536l12.8-23.552c2.048-3.072 3.072-7.168 3.072-11.264 0-12.8-10.24-23.04-23.04-23.04h-343.04l-22.016-46.592H216.576v46.592h46.592l83.456 176.128-31.232 56.832c-3.584 6.656-5.632 14.336-5.632 22.528 0 25.6 20.992 46.592 46.592 46.592H404.48c1.024-3.584 2.56-7.168 4.096-10.752l19.456-36.352z" fill="#AAD4FF" p-id="5628"></path><path d="M680.96 725.504c-25.6 0-46.08 20.992-46.08 46.592s20.48 46.592 46.08 46.592 46.592-20.992 46.592-46.592c0-26.112-20.992-46.592-46.592-46.592zM449.024 725.504c-25.6 0-46.08 20.992-46.08 46.592s20.48 46.592 46.08 46.592 46.592-20.992 46.592-46.592c-0.512-26.112-20.992-46.592-46.592-46.592zM455.168 644.096l18.944-34.816h173.056c17.408 0 32.768-9.728 40.448-24.064l82.944-150.528c2.048-3.072 3.072-7.168 3.072-11.264 0-12.8-10.24-23.04-23.04-23.04h-343.04l-22.016-46.592H309.76v46.592h46.592l71.68 151.04 11.776 25.088-11.776 20.992-19.456 35.84c-2.048 3.584-3.072 7.168-4.096 10.752-1.024 3.584-1.536 7.68-1.536 11.776 0 25.6 20.992 46.592 46.592 46.592h279.04v-46.592H458.752c-3.072 0-5.632-2.56-5.632-5.632 0-1.024 0-2.048 0.512-2.56l1.536-3.584z" fill="#2B95FF" p-id="5629"></path><path d="M223.232 696.32h-29.696v-29.696c0-6.656-5.12-11.776-11.776-11.776s-11.776 5.12-11.776 11.776v29.696h-29.696c-6.656 0-11.776 5.12-11.776 11.776 0 6.656 5.12 11.776 11.776 11.776h29.696v29.696c0 6.656 5.12 11.776 11.776 11.776s11.776-5.12 11.776-11.776v-29.696h29.696c6.656 0 11.776-5.12 11.776-11.776-0.512-6.656-5.632-11.776-11.776-11.776z" fill="#A8D4FF" p-id="5630"></path><path d="M172.032 437.248h65.536v65.536H172.032z" fill="#D9EDFF" p-id="5631"></path><path d="M861.696 655.36m-32.768 0a32.768 32.768 0 1 0 65.536 0 32.768 32.768 0 1 0-65.536 0Z" fill="#D9EDFF" p-id="5632"></path><path d="M825.856 298.496l-89.088-89.088c-3.072-3.072-8.192-4.096-12.8-2.56-4.096 2.048-7.168 6.144-7.168 10.752v89.088c0 3.072 1.536 6.144 3.584 8.192 2.048 2.048 5.12 3.584 8.192 3.584h89.088c4.608 0 8.704-3.072 10.752-7.168 1.536-4.608 0.512-9.728-2.56-12.8z m-86.016-3.584V245.76l49.152 49.152h-49.152z" fill="#A8D4FF" p-id="5633"></path></svg>
            <span>订单管理</span>
          </li> 
          <li 
            @click="navigateTo('messages')"
            :class="{active: activeMenu === 'messages'}">
              <svg t="1765704675860" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5627" width="32" height="32"><path d="M455.168 644.096h179.2V609.28H474.624zM542.208 713.728c0 25.6 20.48 46.592 46.08 46.592s46.592-20.992 46.592-46.592c0-4.096-0.512-7.68-1.536-11.776h-89.6c-1.024 3.584-1.536 7.68-1.536 11.776zM355.84 667.136c-25.6 0-46.08 20.992-46.08 46.592s20.48 46.592 46.08 46.592 46.592-20.992 46.592-46.592-20.48-46.592-46.592-46.592zM428.032 597.504H366.08c-3.072 0-5.632-2.56-5.632-5.632 0-1.024 0-2.048 0.512-2.56l20.992-37.888h46.08l-71.68-151.04h-46.592v-46.592h75.776l22.016 46.592h257.536l12.8-23.552c2.048-3.072 3.072-7.168 3.072-11.264 0-12.8-10.24-23.04-23.04-23.04h-343.04l-22.016-46.592H216.576v46.592h46.592l83.456 176.128-31.232 56.832c-3.584 6.656-5.632 14.336-5.632 22.528 0 25.6 20.992 46.592 46.592 46.592H404.48c1.024-3.584 2.56-7.168 4.096-10.752l19.456-36.352z" fill="#AAD4FF" p-id="5628"></path><path d="M680.96 725.504c-25.6 0-46.08 20.992-46.08 46.592s20.48 46.592 46.08 46.592 46.592-20.992 46.592-46.592c0-26.112-20.992-46.592-46.592-46.592zM449.024 725.504c-25.6 0-46.08 20.992-46.08 46.592s20.48 46.592 46.08 46.592 46.592-20.992 46.592-46.592c-0.512-26.112-20.992-46.592-46.592-46.592zM455.168 644.096l18.944-34.816h173.056c17.408 0 32.768-9.728 40.448-24.064l82.944-150.528c2.048-3.072 3.072-7.168 3.072-11.264 0-12.8-10.24-23.04-23.04-23.04h-343.04l-22.016-46.592H309.76v46.592h46.592l71.68 151.04 11.776 25.088-11.776 20.992-19.456 35.84c-2.048 3.584-3.072 7.168-4.096 10.752-1.024 3.584-1.536 7.68-1.536 11.776 0 25.6 20.992 46.592 46.592 46.592h279.04v-46.592H458.752c-3.072 0-5.632-2.56-5.632-5.632 0-1.024 0-2.048 0.512-2.56l1.536-3.584z" fill="#2B95FF" p-id="5629"></path><path d="M223.232 696.32h-29.696v-29.696c0-6.656-5.12-11.776-11.776-11.776s-11.776 5.12-11.776 11.776v29.696h-29.696c-6.656 0-11.776 5.12-11.776 11.776 0 6.656 5.12 11.776 11.776 11.776h29.696v29.696c0 6.656 5.12 11.776 11.776 11.776s11.776-5.12 11.776-11.776v-29.696h29.696c6.656 0 11.776-5.12 11.776-11.776-0.512-6.656-5.632-11.776-11.776-11.776z" fill="#A8D4FF" p-id="5630"></path><path d="M172.032 437.248h65.536v65.536H172.032z" fill="#D9EDFF" p-id="5631"></path><path d="M861.696 655.36m-32.768 0a32.768 32.768 0 1 0 65.536 0 32.768 32.768 0 1 0-65.536 0Z" fill="#D9EDFF" p-id="5632"></path><path d="M825.856 298.496l-89.088-89.088c-3.072-3.072-8.192-4.096-12.8-2.56-4.096 2.048-7.168 6.144-7.168 10.752v89.088c0 3.072 1.536 6.144 3.584 8.192 2.048 2.048 5.12 3.584 8.192 3.584h89.088c4.608 0 8.704-3.072 10.752-7.168 1.536-4.608 0.512-9.728-2.56-12.8z m-86.016-3.584V245.76l49.152 49.152h-49.152z" fill="#A8D4FF" p-id="5633"></path></svg>
            <span>站内信</span>
          </li>                    
        </ul>
      </div>

      <!-- 内容区 -->
      <div class="content">


        <!-- 加载状态 -->
        <div v-if="!isDataLoaded" class="loading-state">
          <el-skeleton :rows="1" animated />
        </div>
        <!-- 路由视图 -->
        <router-view v-else></router-view>        
    </div>
    <!-- 开通试用版对话框 -->
<el-dialog
  :visible.sync="dialogFreeVersionReadyVisible"
  width="480px"
  custom-class="free-version-dialog"
  :show-close="false"
  :close-on-click-modal="false"
  :close-on-press-escape="false">
  
  <div class="dialog-header">  
    <h2 class="dialog-title">🎉 试用版已开通！</h2>
    <p class="dialog-subtitle">恭喜您成功开通小晖智能客服试用版</p>
  </div>

  <div class="dialog-content">
    <div class="features-list">
      <div class="feature-item">
        <div class="feature-icon">📚</div>
        <div class="feature-text">
          <strong>专属知识库</strong>
          <p>创建专属知识库，让AI更懂您的业务</p>
        </div>
      </div>
      <div class="feature-item">
        <div class="feature-icon">⚡</div>
        <div class="feature-text">
          <strong><i style="color: red;">365</i>天免费试用</strong>
          <p>完整功能体验，快速熟悉系统</p>
        </div>
      </div>
      <div class="feature-item">
        <div class="feature-icon">🎯</div>
        <div class="feature-text">
          <strong>智能客服配置</strong>
          <p>个性化配置，打造专属客服体验</p>
        </div>
      </div>
    </div>

    <div class="action-section">
      <p class="action-hint">立即开始配置您的专属知识库：</p>
      <div class="action-buttons">
        <el-button 
          type="primary" 
          size="medium"
          class="primary-btn"
          @click="goToKnowledge">
          <i class="el-icon-setting"></i>
          立即配置
        </el-button>
        <el-button 
          plain 
          size="medium"
          class="secondary-btn"
          @click="dialogFreeVersionReadyVisible = false">
          稍后再说
        </el-button>
      </div>
    </div>
  </div>
</el-dialog>

    <!-- 退出确认对话框 -->
    <el-dialog
      title="确认退出"
      :visible.sync="dialogLogoutVisible"
      width="30%"
      @closed="handleLogoutDialogClose">
      <p>确定要退出登录吗？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogLogoutVisible = false">取消</el-button>
        <el-button type="primary" @click="logout">确定</el-button>
      </span>
    </el-dialog>

    <!-- 账户设置对话框 -->
    <el-dialog
      title="账户设置"
      :visible.sync="dialogAccountSettingsVisible"
      width="30%"
      @closed="handleAccountSettingsDialogClose">
      <el-form ref="accountSettingsForm" :model="accountSettingsForm" label-width="100px">
        <label for="nickName"> <span class="required-asterisk">*</span>企业简称</label>
            <input
              v-model="accountSettingsForm.nickName"
              type="text"
              id="nickName"
              required
              placeholder="AI客服在沟通时使用简称指代企业"/>
          <!--Logo Upload -->
          <div class="form-group">
            <div class="upload-container">
              <input
                type="file"
                id="logo"
                ref="logoFile"
                accept="image/*"
                @change="handleFileUpload"
                class="file-input">
                <div class="upload-box" @click="triggerFileInput">
                <div v-if="!accountSettingsForm.logoFile" class="upload-placeholder">
                  <span class="plus-icon">+</span>
                  <span class="upload-text">点击上传企业徽标(Logo)</span>
                </div>
                <div v-else class="file-preview">
                  <template v-if="isImageFile(accountSettingsForm.logoFile) || previewImage">
                    <img :src="previewImage" class="thumbnail" alt="企业Logo预览">
                  </template>
                  <template v-else>
                    <span class="file-icon">📄</span>
                    <span class="file-name">{{ accountSettingsForm.logoFile.name }}</span>
                  </template>
                  <button type="button" class="remove-btn" @click.stop="removeFile">×</button>
                </div>
              </div>
              <p class="form-note">请上传清晰的64x64px图片（支持JPG/PNG/JPEG格式）</p>
            </div>
          </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleAccountSettingsDialogClose">取消</el-button>
        <el-button type="primary" @click="handleAccountSettingsSubmit">
          <span v-if="!loading_accountSetting_submit">提交</span>
            <span v-else>
      <i class="el-icon-loading"></i> 提交中...
    </span>
        </el-button>
      </span>

    </el-dialog>


        <!-- 归档文件对话框 -->
        <el-dialog
      title="设置密码"
      :visible.sync="dialogPasswordSettings_smsVisible"
      width="400px"
      @closed="handlePasswordSettings_smsDialogClose">
      <el-form ref="passwordSettings_smsForm" :model="passwordSettings_smsForm" label-width="100px">
        <div class="form-group">
        <label for="username">账户名</label>
            <input
              v-model="passwordSettings_smsForm.username"
              id="username"
              type="text"
              readonly/>
        </div>
          <!--短信验证码 -->
          <div class="form-group">
            <label for="sms-code"><span class="required-asterisk">*</span>验证码</label>
            <div class="sms-group">
              <input
                id="sms-code"
                v-model="passwordSettings_smsForm.code"
                type="text"
                required
                placeholder="6位验证码"
                maxlength="6">
              <button
                type="button"
                class="sms-btn"
                :disabled="isCountingDown || !isPhoneValid"
                @click="sendSMSCode(userInfo.username)">

                <span v-if="!loading_sms"> {{ countdown > 0 ? `${countdown}s后重发` : '获取验证码' }}</span>
    <span v-else>
      <i class="el-icon-loading"></i> 发送中...
    </span>
              </button>
            </div>
            <p v-if="smsError" class="error-message">{{ smsError }}</p>
          </div>
          <div class="form-group">
          <label for="username"><span class="required-asterisk">*</span>确认密码</label>
            <input v-model="passwordSettings_smsForm.password" id="password" type="password"/>
          </div>
          <div class="form-group">
          <label for="username"><span class="required-asterisk">*</span>确认密码</label>
            <input v-model="confirmPassword" id="confirm-password" type="password"/>
          </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handlePasswordSettings_smsDialogClose">取消</el-button>
        <el-button type="primary" @click="handlePasswordSettings_smsSubmit">
          <span v-if="!loading_passwordSetting_submit">提交</span>
            <span v-else>
      <i class="el-icon-loading"></i> 提交中...
    </span>
        </el-button>
      </span>

    </el-dialog>

            <!-- 修改密码对话框 -->
            <el-dialog
      title="修改密码"
      :visible.sync="dialogChangePasswordVisible"
      width="400px"
      @closed="handleChangePasswordDialogClose">
      <el-form ref="changePasswordForm" :model="changePasswordForm" label-width="100px">
        <div class="form-group">
        <label for="username">账户名</label>
            <input
              v-model="changePasswordForm.username"
              id="username"
              type="text"
              readonly/>
        </div>
          <!--原密码 -->
          <div class="form-group">
            <label for="old-password"><span class="required-asterisk">*</span>原密码</label>
              <input
                id="old-password"
                v-model="changePasswordForm.oldPassword"
                type="password"
                required
                placeholder="请输入原密码">
            </div>
          <div class="form-group">
          <label for="new-password"><span class="required-asterisk">*</span>新密码</label>
            <input v-model="changePasswordForm.newPassword" id="new-password" type="password"/>
          </div>
          <div class="form-group">
          <label for="confirm-password"><span class="required-asterisk">*</span>确认密码</label>
            <input v-model="confirmPassword" id="confirm-password" type="password"/>
          </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleChangePasswordDialogClose">取消</el-button>
        <el-button type="primary" @click="handleChangePasswordSubmit">
          <span v-if="!loading_accountSetting_submit">提交</span>
            <span v-else>
      <i class="el-icon-loading"></i> 提交中...
    </span>
        </el-button>
      </span>

    </el-dialog>

            <!-- 租户注销申请反馈对话框 -->
            <el-dialog
      title="租户注销申请反馈"
      :visible.sync="ArchiveFileDownloadVisible"
      width="500px"
      @closed="HandleArchiveFileDownloadDialog">
        <div class="form-group" v-if="this.tenantderegistration">
        <a class="label">申请注销时间：</a>
            <a>{{ formatToBeijingTime(tenantderegistration.apply_datetime) }}</a>
        </div>    
          <div class="form-group" v-if="this.tenantderegistration">
            <a class="label">数据处置方式: </a>
            <a v-if="tenantderegistration.data_protectWay ==1">全部删除</a>
            <a v-if="tenantderegistration.data_protectWay ==2">仅删除个人信息，业务数据归档</a>
            <a v-if="tenantderegistration.data_protectWay ==3">全部导出后删除</a>
            </div>
          <div class="form-group" v-if="this.tenantderegistration">
            <a class="label">状态: </a>
            <a v-if="tenantderegistration.status ==0">申请注销</a>
            <a v-if="tenantderegistration.status ==1">批准</a>
            <a v-if="tenantderegistration.status ==2">拒绝</a>
            </div>            
          <div class="form-group" v-if="this.tenantderegistration && tenantderegistration.status==2 && tenantderegistration.reject_reason">
          <label  style="width: 180px;">拒绝原因</label>
                        <a>{{ tenantderegistration.reject_reason }}</a>
          </div>
          <div class="form-group">
             <a class="label">审核时间: </a>
            <a>{{ tenantderegistration==null?"-":tenantderegistration.verify_datetime==null?"-": formatToBeijingTime(this.tenantderegistration.verify_datetime)}}</a>
          </div>
          <div class="form-group" v-if="tenantderegistration && tenantderegistration.archive_excel_url">
             <a class="label">归档文件: </a>
            <a style="cursor: pointer;" @click="handleDownload()" title='点击下载'><svg t="1792848361180" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5676" width="32" height="32"><path d="M768 480v256a32 32 0 0 1-32 32H288a32 32 0 0 1-32-32v-256a32 32 0 0 1 32-32h448a32 32 0 0 1 32 32z m-64 32H320v192h384v-192z m-384-160h384a32 32 0 0 1 0 64H320a32 32 0 1 1 0-64z m32-96h320a32 32 0 0 1 0 64H352a32 32 0 1 1 0-64z m96 320h128a32 32 0 0 1 0 64h-128a32 32 0 0 1 0-64z" fill="#1296db" p-id="5677"></path></svg></a>
          </div>          
    </el-dialog>    
    
            <!-- 租户申请恢复状态对话框 -->
            <el-dialog
      title="申请恢复租户状态"
      :visible.sync="deregistrationRestoreApplyVisible"
      width="500px"
      @closed="HandlederegistrationRestoreApplyCloseDialog">
 <el-form ref="deregistrationRestoreForm" :model="deregistrationRestoreForm" label-width="100px">      
        <div class="form-group" v-if="this.tenantderegistration">
        <a class="label">申请注销时间：</a>
            <a>{{ this.tenantderegistration==null?"-": formatToBeijingTime(this.tenantderegistration.apply_datetime) }}</a>
        </div>  
                <div class="form-group" v-if="this.tenantderegistration">
        <a class="label">冷静期：</a>
            <a>{{ formatToBeijingTime(tenantderegistration.apply_datetime) +'~' + formatToBeijingTime(tenantderegistration.buffer_start_datetime) }}</a>
        </div>    
        <div class="form-group" v-if="this.tenantderegistration">
        <a class="label">缓冲期：</a>
            <a>{{ formatToBeijingTime(tenantderegistration.buffer_start_datetime) +'~' + formatToBeijingTime(tenantderegistration.buffer_end_datetime) }}</a>
        </div>        
          <div class="form-group" v-if="this.tenantderegistration">
            <a class="label">数据处置方式: </a>
            <a v-if="tenantderegistration.data_protectWay ==1">全部删除</a>
            <a v-if="tenantderegistration.data_protectWay ==2">仅删除个人信息，业务数据归档</a>
            <a v-if="tenantderegistration.data_protectWay ==3">全部导出后删除</a>
            </div>
          <div class="form-group" v-if="this.tenantderegistration">
            <a class="label">状态: </a>
            <a v-if="tenantderegistration.status ==0">申请注销</a>
            <a v-if="tenantderegistration.status ==1">批准</a>
            <a v-if="tenantderegistration.status ==2">拒绝</a>
            </div>            
 <div class="form-group" v-if="this.tenantderegistration">
            <a class="label"><span class="required-asterisk">*</span>恢复原因: </a>
                   <input type="hidden" v-model="deregistrationRestoreForm.apply_id" />
                   <textarea          
                   style="width:280px"          
                    v-model="deregistrationRestoreForm.reason"                                    
          rows="3"
        ></textarea>
        </div>  

        <div class="form-group" >
        <a class="label">管理员手机号：</a>
            <a>{{ tenantInfo.adminUsername }}</a>
        </div>          
<!--短信验证码 -->          
          <div class="sms-group">
              <a class="label"><span class="required-asterisk">*</span>短信验证码：</a>              
              <input
                id="sms-code"
                v-model="deregistrationRestoreForm.code"
                type="text"
                required
                placeholder="6位验证码"
                maxlength="6">
              <button
                type="button"
                class="sms-btn"
                :disabled="isCountingDown || !isPhoneValid"
                @click="sendSMSCode(userInfo.username)">

                <span v-if="!loading_sms"> {{ countdown > 0 ? `${countdown}s后重发` : '获取验证码' }}</span>
    <span v-else>
      <i class="el-icon-loading"></i> 发送中...
    </span>
              </button>
            </div> 
      </el-form>                        
      <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitDetregistrationRestoredataApply">确 定</el-button>
          <el-button type="plain" @click="cancelauthentication">取 消</el-button>
        </div>        
    </el-dialog> 
      
    <!-- 变更管理员对话框 -->
    <el-dialog
      title="变更管理员"
      :visible.sync="dialogChangeAdminVisible"
      width="400px"
      @closed="handleChangeAdminDialogClose">
      <el-form ref="changeAdminForm" :model="changeAdminForm" label-width="100px">
        <div class="form-group">
        <label for="username">原手机号</label>
            <input
              v-model="changeAdminForm.username"
              id="username"
              type="text"
              readonly/>
        </div>
        <div class="form-group">
          <label for="new-password"><span class="required-asterisk">*</span>验证码</label>
            <input v-model="changeAdminForm.code1" id="code1" placeholder="原手机验证码" type="text"/>
          </div>
          <!--新手机号 -->
          <div class="form-group">
            <label for="newPhone"><span class="required-asterisk">*</span>新手机号</label>
              <input
                id="newPhone"
                v-model="changeAdminForm.newPhone"
                type="text"
                placeholder="请输入新手机号">

            </div>
            <div class="form-group">
          <label for="new-password"><span class="required-asterisk">*</span>验证码</label>
            <input v-model="changeAdminForm.code2" id="code2" placeholder="新手机验证码" type="text"/>
          </div>

          <div class="form-group">
          <label for="confirm-password"><span class="required-asterisk">*</span>新姓名</label>
            <input v-model="changeAdminForm.newName" id="newName" type="text" placeholder="请输入新管理员姓名"/>

          </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="sendSMSCode_change_admin">发送验证码</el-button>
        <el-button @click="handleChangePasswordDialogClose">取消</el-button>
        <el-button type="primary" @click="handleChangeAdminSubmit">
          <span v-if="!loading_changeAdmin_submit">提交</span>
            <span v-else>
      <i class="el-icon-loading"></i> 提交中...
    </span>
        </el-button>
      </span>

    </el-dialog>
<!-- 协议与隐私 -->
    <el-dialog
      title="协议与隐私"
      :visible.sync="dialogAgreementVisible"
      width="80%"
    >
    <AgreementView :userInfo="userInfo"  />
    </el-dialog>  

    
        <!-- 退出确认对话框 -->
    <el-dialog
      title="提交注销申请"
      :visible.sync="dialogDeregistrationApllyVisible"
      width="750px"
      @closed="HandleDelregistrationApplyClose">
      <a><svg t="1792282159628" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5636" width="16" height="16"><path d="M198.656 441.898667c5.546667-92.885333 55.893333-174.208 131.328-225.024l-52.906667-50.133334c-88.405333 63.786667-146.858667 162.986667-152.405333 275.157334h73.984z m495.018667-225.024c75.818667 50.816 126.165333 132.138667 131.712 225.024h73.984c-5.546667-112.170667-64-211.370667-152.789334-275.157334l-52.906666 50.133334z m58.837333 435.328v-192.768c0-107.605333-78.805333-197.674667-185.002667-221.525334v-23.850666c0-29.056-24.746667-52.565333-55.466666-52.565334-30.72 0-55.509333 23.466667-55.509334 52.565334v23.850666c-106.197333 23.850667-185.002667 113.92-185.002666 221.525334v192.768L197.546667 722.304v35.029333h628.906666v-35.029333l-73.941333-70.101333z m-314.453333 140.202666c0 38.528 33.28 70.101333 73.941333 70.101334 5.205333 0 10.026667-0.384 14.805333-1.408a72.789333 72.789333 0 0 0 53.290667-41.386667 67.413333 67.413333 0 0 0 5.930667-27.306667h-148.010667z" fill="#FF4D4F" p-id="5637"></path></svg>
       &nbsp;<b>重要提醒</b>：注销后将导致以下后果，请仔细阅读。</a><br/>
      <el-row :gutter="10" class="mb8">
        <el-col :span="12">
          <a style="margin-left: 10px; margin-top: 0;">①&nbsp; 所有员工将无法登录本租户后台</a>
        </el-col> 
        <el-col :span="12">
           <a  style="margin-left: 10px;">②&nbsp; AI客服机器人将停止服务</a>
        </el-col>          
      </el-row>  
      <el-row :gutter="10" class="mb8">
        <el-col :span="12">
          <a  style="margin-bottom: 5px; margin-left: 10px;">③&nbsp; 所有对话记录、知识库、工单将被处置</a>
        </el-col> 
        <el-col :span="12">
          <a  style="margin-bottom: 5px; margin-left: 10px;">④&nbsp; 已购买的套餐及流量包将无法继续使用</a>
        </el-col>          
      </el-row>        
       <el-row :gutter="10" class="mb8">
        <el-col :span="24">
          <a  style="margin-bottom: 5px; margin-left: 10px; margin-top: 0;">⑤&nbsp; 租户名称及相关品牌信息将从平台移除</a>
        </el-col>         
      </el-row> 
             

           
         
             <div class="menu-divider"></div> 
             
              <el-row :gutter="10" class="mb8">
                <el-col :span="24">
                  <a  style="margin-bottom: 5px; margin-left: 10px;">📋 请确认以下事项</a>
                </el-col>           
      </el-row>      
            <el-row :gutter="10" class="mb8">
        <el-col :span="12">
          <input type="checkbox" v-model="check1"/>
              我已阅读并理解上述注销后果
        </el-col> 
        <el-col :span="12">
            <input type="checkbox" v-model="check3"/>
              我已知晓在冷静期中我可以备份需要保留的数据
        </el-col>          
      </el-row>    
            <el-row :gutter="10" class="mb8">
        <el-col :span="12">
          <input type="checkbox" v-model="check2"/>
              我已通知本租户所有员工用户
        </el-col> 
        <el-col :span="12">
           <input type="checkbox" v-model="check4"/>
              我确认本租户无正在进行的未完结工单或纠纷
        </el-col>          
      </el-row>                        
             
                           
                 
             
      <div class="menu-divider"></div>               
      <el-row :gutter="10" class="mb8">
        <el-col :span="24">
          <div class="form-group"></div>
            <label>上传加盖公章的《租户终止服务申请书》照片</label>
            <PicUploader
              ref="PicUploader"
              :value="pic_url"
              mode="edit"
              @file-change="onPicFileChange" 
            /> 
        </el-col>          
      </el-row>                
      <el-row :gutter="10" class="mb8">
        <el-col :span="24">
         <a cstyle="font-family:宋体;font-size:small;color:#474747">💡 填写说明：需填写租户名称、统一社会信用代码、申请人信息；需勾选数据处置方式；需加盖公章或由法定代表人签字。</a>
         
        </el-col>
        </el-row>
      <div class="menu-divider"></div> 
      <el-row :gutter="10" class="mb8">
        <el-col :span="24">
         <a cstyle="font-family:宋体;font-size:small;color:#474747">📊 数据处置方式</a>         
        </el-col>
      </el-row>
      <el-row :gutter="10" class="mb8">
        <el-col :span="12">          
         <input
  type="checkbox"
  class="radio-style-checkbox" 
  v-model="data_process1"
  @change="opChange1($event.target.checked)"
/>全部删除
        </el-col>    
        <el-col :span="12">
          <a cstyle="font-family:宋体;font-size:small;color:#474747;  
    appearance: none !important;
    -webkit-appearance: none !important;
    width: 18px !important;
    height: 18px !important;
    border: 1px solid #409EFF !important;
    border-radius: 50% !important;
    background: #fff !important;
    position: relative !important;
    cursor: pointer !important;
    vertical-align: middle !important;
    margin-right: 6px !important;
    box-sizing: border-box !important;
  "> 所有业务数据将被永久删除，不可恢复</a><br/>
          <a cstyle="font-family:宋体;font-size:small;color:#474747">⚠️ 建议：仅在您确定不再需要任何数据时选择此项</a><br/>              
        </el-col>          
      </el-row>   
      <el-row :gutter="10" class="mb8">
        <el-col :span="12" style="background-color: aliceblue;">          
          <input
  type="checkbox"
  class="radio-style-checkbox"
  v-model="data_process2"
  @change="opChange2($event.target.checked)"
/>仅删除个人信息，业务数据归档
        </el-col>    
        <el-col :span="12" style=" background-color: aliceblue">
          <a cstyle="font-family:宋体;font-size:small;color:#474747; "> 个人信息将被删除，业务数据由平台归档保留</a><br/>
          <a cstyle="font-family:宋体;font-size:small;color:#474747">  ℹ️ 归档数据不不支持数据恢复，仅供人工查阅</a>              
        </el-col>          
      </el-row> 
      <el-row :gutter="10" class="mb8">
        <el-col :span="12">          
          <input
  type="checkbox"
  class="radio-style-checkbox" 
  v-model="data_process3"
  @change="opChange3($event.target.checked)"
/>全部导出后删除 
        </el-col>    
        <el-col :span="12">
          <a cstyle="font-family:宋体;font-size:small;color:#474747"> 平台将打包所有业务数据供你下载，下载完成后删除</a><br/>
          <a cstyle="font-family:宋体;font-size:small;color:#474747"> ℹ️ 导出文件将以ZIP格式按模块分目录组织</a><br/>              
        </el-col>          
      </el-row>   
      <div class="menu-divider"></div> 
      <el-row :gutter="10" class="mb8">   
        <el-col :span="24">
          <a style="font-family:宋体;font-size:small;color:#474747">📅 <b>冷静期说明</b> </a>                        
        </el-col>          
      </el-row>      
       <el-row :gutter="10" class="mb8">   
        <el-col :span="24">
          <a style="font-family:宋体;font-size:small;color:#474747;margin-left: 15px;">提交申请后，将进入7天冷静期。在此期间： </a>                        
        </el-col>          
      </el-row>    
       <el-row :gutter="10" class="mb8">   
        <el-col :span="24">
          <a style="font-family:宋体;font-size:small;color:#474747;margin-left: 30px;">• 您可以随时撤销注销申请，所有数据保持不变。</a>                        
        </el-col>          
      </el-row>    
      <el-row :gutter="10" class="mb8">   
        <el-col :span="24">
          <a style="font-family:宋体;font-size:small;color:#474747;margin-left: 30px;">• 租户仍可正常使用（但建议尽快备份数据）。 </a>                        
        </el-col>          
      </el-row>    
       <el-row :gutter="10" class="mb8">   
        <el-col :span="24">
          <a style="font-family:宋体;font-size:small;color:#474747;margin-left: 15px;">冷静期满后，将按所选方式执行数据处置。</a>                        
        </el-col>          
      </el-row>
             <el-row :gutter="10" class="mb8">   
        <el-col :span="24">
          <a style="font-family:宋体;font-size:small;color:#474747;margin-left: 15px;">冷静期后，仍有30天保留期可供下载数据。</a>                        
        </el-col>          
      </el-row>          
      <!-- 🔒 平台依法保留的数据-->  
    <div class="message-menu-divider"></div>       
      <el-row :gutter="10" class="mb8">   
        <el-col :span="24">
          <a style="font-family:宋体;font-size:small;color:#474747">🔒 <b>  平台依法保留的数据</b> </a>                                    
        </el-col>          
      </el-row>   
            <el-row :gutter="10" class="mb8">   
        <el-col :span="24">         
              <a style="font-family:宋体;font-size:small;color:#474747;margin-left: 22px;">以下数据不随租户注销而删除，将依法保留：</a>              
        </el-col>          
      </el-row> 
      <el-row :gutter="10" class="mb8">   
        <el-col :span="24">         
              <a style="font-family:宋体;font-size:small;color:#474747;margin-left: 30px;">•  订单及支付记录（保留10年，用于财务审计）。 </a>              
        </el-col>          
      </el-row>         
      <el-row :gutter="10" class="mb8">   
        <el-col :span="24">         
              <a style="font-family:宋体;font-size:small;color:#474747;margin-left: 30px;">•  操作日志及审计记录（保留6个月以上，用于安全溯源）。 </a>              
        </el-col>          
      </el-row>   
      <el-row :gutter="10" class="mb8">   
        <el-col :span="24">         
              <a style="font-family:宋体;font-size:small;color:#474747;margin-left: 30px;">•   发票记录（按税法要求保留）。 </a>              
        </el-col>          
      </el-row>          
      <span slot="footer" class="dialog-footer">
        <el-button @click="HandleDelregistrationApplyClose">取消</el-button>
        <el-button type="primary" @click="submitDetregistrationApply">
          <span v-if="!loading_accountSetting_submit">提交</span>
            <span v-else>
      <i class="el-icon-loading"></i> 提交中...
    </span>
        </el-button>
      </span>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
//import ParticlesBackground from '@/components/ParticlesBackground.vue'

import { postBrief } from '@/api/tenant/settings'
import { postTenantDeregistrationRestoredataApply } from '@/api/tenant/tenant'
import { getUnreadCount} from '@/api/tenant/message'
import AgreementView from '@/components/Agreement.vue'
import { send_sms_code } from '@/api/common'
import { set_password_sms, change_password,change_admin} from '@/api/auth/user'
import PicUploader from '@/components/PicUploader.vue'
import { postTenantDeregistrationApply, get_my_tenant_deregistration_info } from '@/api/tenant/tenant'
import {save_log} from '@/api/tenant/TenantOperationLogs'
import { formatToBeijingTime } from '@/util/date';
export default {
  name: 'AdminMain',
  components: {
    //ParticlesBackground,
    AgreementView,     
    PicUploader
  },
  directives: {
    'click-outside': {
      bind(el, binding) {
        el.clickOutsideEvent = function(event) {
          // 检查点击是否在元素外部
          if (!(el === event.target || el.contains(event.target))) {
            // 调用指令绑定的方法
            binding.value(event);
          }
        };
        // 添加点击事件监听
        document.addEventListener('click', el.clickOutsideEvent);
      },
      unbind(el) {
        // 移除事件监听
        document.removeEventListener('click', el.clickOutsideEvent);
      }
    }
  },
  data() {
    return {
         // 实体类型选项
    orgTypeOptions: [
      { dictValue: '1', dictLabel: '企业' },
      { dictValue: '2', dictLabel: '个体工商户' },
      { dictValue: '3', dictLabel: '政府与事业单位' },
      { dictValue: '4', dictLabel: '社会组织' },
      { dictValue: '5', dictLabel: '个人开发者' }
    ],
      isDropdownOpen: false,
      feedbackUnread: 0, //意见反馈未读消息数量
      inboxUnread:0,
      batchmessageUnread: 0, //批量消息未读数量
      dialogLogoutVisible: false,
      dialogAccountSettingsVisible: false,
      dialogPasswordSettings_smsVisible: false,
      dialogChangePasswordVisible: false,
      dialogChangeAdminVisible: false,
      loading_passwordSetting_submit: false, // 加载状态
      dialogAgreementVisible: false,      
      dialogFreeVersionReadyVisible: false,
      workspaceSlug: '',
      workspaceName: '',
      dialogDeregistrationApllyVisible: false,
      passwordSettings_smsForm: {
        username: '',
        oldPassword: '',
        newPassword: '',
      },
      changePasswordForm: {
        username: '',
        code: '',
        password: '',
      },
      loading_changeAdmin_submit: false, // 加载状态
      changeAdminForm: {
        username: '',
        code1: '',
        code2: '',
        newPhone: '',
        newName: '',
      },
      confirmPassword: '',
      loading_sms: false, // 加载状态
      isPhoneValid: false,
      smsError: '',
      countdown: 0,
      isDataLoaded: false,
      previewImage: null,
      loading_accountSetting_submit: false,
      accountSettingsForm: {
        nickName: '',
        logoFile: null,
        previewImage: null,
      },
      passwordRules: {
        minLength: 6,
        maxLength: 20,
        requireLetter: true,
        requireNumber: true
        // 可扩展：requireSpecialChar: true
      },
      dialogOpenCount: 0,
      // 注销账户对话框相关变量
      check1: false, // 我已阅读并理解上述注销后果
      check2: false, // 我已通知本租户所有员工
      check3: false, // 我已备份需要保留的数据 
      check4: false, // 我确认本租户无正在进行的未完结工单或纠纷 
      data_process1:false, // 数据处置方式，选项1）全部删除
      data_process2:false, // 数据处置方式，选项2）仅删除个人信息，业务数据归档
      data_process3:false, // 数据处置方式，选项3） 全部导出后删除

      pic_url: '',  // 上传《租户终止服务申请书图片
      picFile: null,
 
      // =================
         loading_feedback_submit: false,  // 反馈提交加载状态
    // 站内信相关
    messageDropdownVisible: false,  // 站内信下拉菜单显示状态
    unreadCount: 0,                // 未读消息数量
    feedbackDialogVisible: false,  // 意见反馈弹窗显示状态
    deregistrationRestoreApplyVisible:false, //申请恢复租户状态弹框
    feedbackForm: {               // 意见反馈表单
      title: '',
      content: '',
      category: 'SUGGESTION',
      priority: 3
    },
    feedbackRules: {             // 反馈表单验证规则
      title: [
        { required: true, message: '请输入反馈标题', trigger: 'blur' },
        { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
      ],
      content: [
        { required: true, message: '请输入反馈内容', trigger: 'blur' },
        { min: 5, max: 500, message: '长度在 5 到 500 个字符', trigger: 'blur' }
      ]
    },
    feedbackCategories: [        // 反馈分类
      { value: 'BUG', label: '问题反馈' },
      { value: 'SUGGESTION', label: '功能建议' },
      { value: 'QUESTION', label: '产品咨询' },
      { value: 'COMPLAINT', label: '投诉' },
      { value: 'OTHER', label: '其他' }
    ],
    // 注销相关
    tenant_deregistration: null,
    tenantderegistration: null,
    ArchiveFileDownloadVisible: false,
      deregistrationRestoreForm: {
        apply_id:0,
        reason: '',
        code: ''
      }
    }
  },
  computed: {
    ...mapState('auth', ['tenantInfo', 'userInfo','loginType']),
  
  isEditingQualification() {
    return this.title_change_register_info !== '我的资质';
  }, 
   dialogTitle() {
    return this.title_change_register_info
  },   
        // 总未读消息数（收件箱 + 反馈）
  totalUnread() {
    console.log("this.batchmessageUnread",this.batchmessageUnread)
    return (this.inboxUnread || 0) + (this.feedbackUnread || 0) + (this.batchmessageUnread || 0)
  },
    isCountingDown() {
      return this.countdown > 0
    },
    // 计算当前激活的菜单
    activeTab() {
      return this.$route.name || 'dashboard'
    },
   // 添加计算当前激活菜单
    activeMenu() {
      const routeName = this.$route.name
      const menuMap = {
        'AdminDashboard': 'dashboard',
        'AdminEmployees': 'employees',
        'AdminKnowledge': 'knowledge',
        'KnowledgeWorkspace': 'knowledge', // 文档页也属于知识库菜单
        'ImageLibrary': 'imagelibrary',
        'AdminOperationLog': 'operationlog',
        'StatisticsCenter': 'statisticsCenter',
        'PlanAndPackage': 'plan-and-package',
        'Cart': 'cart',
        'orders': 'orders',
        'OrderSuccess': 'orders', // 添加支付成功页也属于订单管理
        'messages': 'messages'
      }
      return menuMap[routeName] || 'dashboard'
    }    

  },
 async mounted() {
      this.checkAuth()
      this.isPhoneValid = /^1[3-9]\d{9}$/.test(this.userInfo.username)
//      this.checkCountdown();
  console.log("this.userInfo", this.userInfo);  

console.log("tenantInfo", this.tenantInfo);
 try {
  get_my_tenant_deregistration_info(this.tenantInfo?.tenantId)
    .then(response => {
      console.log("this.tenantderegistration response", response);
      
      if (response && response.code === 200) {
        console.log("code:", response.code);           // 200
        console.log("data:", response.data);            // {id: 8, tenant_id: 22, ...}
        console.log("message:", response.message);      // "操作成功"
        
        this.tenantderegistration = response.data;
        console.log("this.tenantderegistration", this.tenantderegistration);
        this.deregistrationRestoreForm.apply_id = this.tenantderegistration.id;
      }
    })
  }catch(error) {
      console.error("获取租户注销信息失败:", error);
    }


console.log("loginType", this.loginType);


const today = new Date()

console.log(today.getFullYear(), today.getMonth(), today.getDate());
      if(this.tenantInfo.logoUrl == null){
        this.tenantInfo.logoUrl = "https://aics-public.oss-cn-beijing.aliyuncs.com/images/default_avatar.png";
      }
//      console.log(this.tenantInfo.versionStartDate[0] , this.tenantInfo.versionStartDate[1], this.tenantInfo.versionStartDate[2]  )
      if(this.tenantInfo.versionStartDate!=null  &&
        this.tenantInfo.versionStartDate.length > 3 &&
        this.tenantInfo.versionStartDate[0] == today.getFullYear() &&
        this.tenantInfo.versionStartDate[1] == (today.getMonth()+1) &&
        this.tenantInfo.versionStartDate[2] == today.getDate()){
          this.dialogFreeVersionReadyVisible = true;
        }
        this.loadUnreadCount();
        this.logoPreviewImage = this.tenantInfo.logoUrl
        console.log("this.logoPreviewImage", this.logoPreviewImage)
    },
  methods: {
    ...mapActions('auth', ['logout']), // ogout action
    
        formatToBeijingTime(time){
           return  formatToBeijingTime(time);
        },


        async handleDownload() {
          const url = this.tenantderegistration.archive_excel_url
          console.log('下载URL:', url)

          try {
            const res = await fetch(url, { method: 'GET' })
            console.log('status:', res.status)
            console.log('ACAO头:', res.headers.get('access-control-allow-origin'))

            if (!res.ok) throw new Error('HTTP ' + res.status)

            const blob = await res.blob()
            const objUrl = URL.createObjectURL(blob)

            const a = document.createElement('a')
            a.href = objUrl
            a.download = '租户数据归档.zip'
            document.body.appendChild(a)
            a.click()
            a.remove()
            URL.revokeObjectURL(objUrl)
          } catch (e) {
            console.error('真实错误:', e)
            // 兜底：直接跳链接（不读流，不触发 CORS 读取）
            window.open(url, '_blank')
          }
        },

        opChange1(checked) {
          if(checked){
            this.data_process2 = false;
            this.data_process3 = false;
          }
    },
     opChange2(checked) {
          if(checked){
            this.data_process1 = false;
            this.data_process3 = false;
          }
    },
        opChange3(checked) {
          if(checked){
            this.data_process2 = false;
            this.data_process1 = false;
          }
    },    

      onPicFileChange(file) {
        // file 可能是 File 或 null
        this.picFile = file
      },
 // 提交注销申请
    async submitDetregistrationApply() {
      if(!this.check1){
          this.$message.error('请阅读并理解注销后果');        
          return;
      }
      if(!this.check2){
          this.$message.error('请确认您已通知本租户所有员工用户');        
          return;
      }
      if(!this.check2){
          this.$message.error('请确认您已通知本租户所有员工用户');        
          return;
      }  
      if(!this.check3){
          this.$message.error('请确认您已知晓在冷静期中您可以备份需要保留的数据');        
          return;
      }
      if(!this.check4){
          this.$message.error('请确认您的租户无正在进行的未完结工单或纠纷');        
          return;
      }    
      let response = null;
      this.loading_accountSetting_submit = true  // 复用加载状态
      try {
        const formData = new FormData();        
        formData.append('tenant_id', this.tenantInfo?.tenantId);
                if (this.picFile) {
          formData.append('picFile', this.picFile);        
        }
        let data_protect_way=0;
        if(this.data_process1)
          data_protect_way = 1;
        if(this.data_process2)
          data_protect_way = 2;
        if(this.data_process3)
          data_protect_way = 3;
          formData.append('data_protect_way', data_protect_way);       
             response = await postTenantDeregistrationApply(formData);
        console.log("postTenantDeregistrationApply", response);
        if(response.data.code === 200) {
            const formDatalog = new FormData();
            formDatalog.append("operation_type", "TENANT_DEREGISTRATION_APPLY_SUBMIT")
            formDatalog.append("operation_content", "租户注销申请已经提交。")
            save_log(
              {
                "operation_type": "TENANT_DEREGISTRATION_APPLY_SUBMIT",
                "operation_content": "租户注销申请已经提交。。"
              }
            );
          this.dialogDeregistrationApllyVisible = false
          this.$message.success(response.data?.message || '提交成功');

       
          this.open_change_register_info = false;
        } else {
          this.$message.error(response.data?.message || '提交失败');
        }
      } catch (error) {
        console.error('提交注销申请失败:', error);
        this.$message.error(error.response?.data?.message || '提交失败');
      } finally {
        this.loading_accountSetting_submit = false
      }
    },  
    // 处理文件选择
    handleLicenceFileChange(event) {
      const file = event.target.files[0]
      if (!file) return
      
      this.register_info_changeForm.licenceFile = file
      
      const reader = new FileReader()
      reader.onload = (e) => {
        this.licensePreviewImage = e.target.result
        this.$forceUpdate()
      }
      reader.readAsDataURL(file)
    }, 
    // 弹框关闭时的回调
    handleDialogClose() {
      this.register_info_changeForm.licenceFile = null
      this.licensePreviewImage = null
      if (this.$refs.licenceFile) {
        this.$refs.licenceFile.value = ''
      }
    },  
       /**
     * 加载未读消息数量
     */
    async loadUnreadCount() {
      try {
        const response = await getUnreadCount()
        console.log('未读数量响应:', response) 
        
        if (response.code === 200 && response.data) {
          // 根据后端返回的实际字段名调整
          this.inboxUnread = response.data.inboxUnread || 0
          this.feedbackUnread = response.data.feedbackUnread || 
                                response.data.feedback || 0
          this.batchmessageUnread = response.data.batchmessageUnread || 0
          
          console.log('收件箱未读:', this.inboxUnread)
          console.log('意见反馈未读:', this.feedbackUnread)
          console.log("群发消息未读：", this.batchmessageUnread)
        }
      } catch (error) {
        console.error('加载未读数量失败:', error)
      }
    },
    /**
     * 切换站内信下拉菜单
     */
    toggleMessageDropdown() {
      this.messageDropdownVisible = !this.messageDropdownVisible
      // 如果打开下拉菜单，刷新未读数量
      if (this.messageDropdownVisible) {
        this.loadUnreadCount()
      }
    },    
    /**
     * 关闭站内信下拉菜单
     */
    closeMessageDropdown() {
      this.messageDropdownVisible = false
    },

    /**
     * 跳转到收件箱
     */
    goToInbox() {
      this.closeMessageDropdown()
      this.$router.push({ name: 'messages' })
    },
      /**
     * 跳转到收件箱
     */
    goToBatch() {
      this.closeMessageDropdown()
      this.$router.push({ name: 'batch-messages' })
    },
// 打开意见反馈列表页
openFeedbackList() {
  this.closeMessageDropdown()
  this.$router.push({ name: 'FeedbackList' })
},
  
    /**
     * 提交意见反馈
     */
    async submitFeedback() {
      // 表单验证
      if (!this.feedbackForm.title) {
        this.$message.error('请输入反馈标题')
        return
      }
      if (this.feedbackForm.title.length < 2 || this.feedbackForm.title.length > 50) {
        this.$message.error('反馈标题长度在 2-50 个字符之间')
        return
      }
      if (!this.feedbackForm.content) {
        this.$message.error('请输入反馈内容')
        return
      }
      if (this.feedbackForm.content.length < 5 || this.feedbackForm.content.length > 500) {
        this.$message.error('反馈内容长度在 5-500 个字符之间'+ this.feedbackForm.content.length)
        return
      }
      
      this.loading_feedback_submit = true
      
      try {
        // 这里需要根据你的实际API来调用
        // 假设你有一个发送反馈的API
        const { sendFeedback } = await import('@/api/tenant/message')        
        
        const requestData = {
          title: this.feedbackForm.title,
          content: this.feedbackForm.content,
          category: this.feedbackForm.category,
          priority: this.feedbackForm.priority
        }
        
        const response = await sendFeedback(requestData)
        
        if (response.code === 200) {
          this.$message.success('反馈提交成功，感谢您的建议！')
          this.feedbackDialogVisible = false
        } else {
          this.$message.error(response.message || '提交失败，请稍后重试')
        }
      } catch (error) {
        console.error('提交反馈失败:', error)
        this.$message.error('提交失败: ' + (error.message || '未知错误'))
      } finally {
        this.loading_feedback_submit = false
      }
    },
    
    /**
     * 关闭反馈弹窗
     */
    handleFeedbackDialogClose() {
      this.feedbackDialogVisible = false
      this.feedbackForm = {
        title: '',
        content: '',
        category: 'SUGGESTION',
        priority: 3
      }
    },   
  getOrgTypeStr(val){
    if(val ===1)
      return '企业';
    if(val === 2)
      return '个体工商户'
    if(val === 3)
      return '政府与事业单位';
    if(val === 4)
       return '个体工商户';
    if(val === 5)
    return '个人开发者/创作者';

  },

HandleOrgTypeChange(val) {
  val = Number(val)
  if (!val) return
  const labels = {
    1: { name: '企业名称', code: '统一社会信用代码', pic: '营业执照照片/扫描件' },
    2: { name: '个体工商户名称', code: '统一社会信用代码', pic: '个体工商户营业执照' },
    3: { name: '政府与事业单位名称', code: '统一社会信用代码', pic: '统一社会信用代码证书/事业单位法人证书' },
    4: { name: '社会组织名称', code: '统一社会信用代码', pic: '社会组织登记证书/慈善组织公开募捐资格证书' },
    5: { name: '开发/创作者名称', code: '身份证号码', pic: '个人身份证件、辅助证明材料' }
  }
  const label = labels[val]
  if (label) {
    this.labelOrgNameText = label.name
    this.labelOrgCodeText = label.code
    this.labelOrgPicText = label.pic
  }
},
/**
     * 资质证明相关方法
     */
    triggerLicenceFileInput() {
      this.$refs.licenceFile.click()
    },  
  // 删除营业执照图片
  removeLicenceFile(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    
    this.register_info_changeForm.licenceFile = null
    this.licensePreviewImage = null
    
    if (this.$refs.licenceFile) {
      this.$refs.licenceFile.value = ''
    }
    
    this.$forceUpdate()
  },
 
  
    async checkTokenAndRefresh() {
    const token = this.$store.state.auth.token
    const refreshToken = this.$store.state.auth.refreshToken

    // 如果有refreshToken但token过期，尝试刷新
    if (refreshToken && (!token || this.isTokenExpired(token))) {
      try {
        await this.$store.dispatch('auth/refreshToken')
        return true
      } catch (error) {
        console.error('Token刷新失败:', error)
        return false
      }
    }
    return true
  },

   cancelRegisterInfoChange() {
      // 重置所有字段的变化状态
      Object.keys(this.fieldChanged).forEach(key => {
        this.fieldChanged[key] = false;
      });
      
      // 重置表单值为原始值
      if (this.registerInfoForm) {
        this.register_info_changeForm = { ...this.registerInfoForm };
      }                                                                                                             
      
      this.open_change_register_info = false;
    },        
  // 跳转到知识库配置
  goToKnowledge() {
      this.dialogFreeVersionReadyVisible = false
      this.$router.push({ name: 'AdminKnowledge' })
  },
  checkFreeVersionDialog() {
      // 检查本地存储中是否已经显示过
      const hasShownDialog = localStorage.getItem('freeVersionDialogShown')
      
      // 检查是否是新开通试用版的用户
      const today = new Date()
      if (this.tenantInfo.versionStartDate != null &&
          this.tenantInfo.versionStartDate.length > 3 &&
          this.tenantInfo.versionStartDate[0] == today.getFullYear() &&
          this.tenantInfo.versionStartDate[1] == (today.getMonth() + 1) &&
          this.tenantInfo.versionStartDate[2] == today.getDate() &&
          !hasShownDialog) {
        
        // 延迟显示，让页面先加载完成
        setTimeout(() => {
          this.dialogFreeVersionReadyVisible = true
          // 标记为已显示，确保只弹出一次
          localStorage.setItem('freeVersionDialogShown', 'true')
        }, 1000)
      }
  },  
  isTokenExpired(token) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]))
      return payload.exp * 1000 < Date.now()
    } catch (e) {
      return true
    }
  },
 // 处理标签切换
 handleTabChange(tab, slug,name) {
      this.currentTab = tab
      this.workspaceSlug = slug || ''
      this.workspaceName = name || ''
    },
// 修改菜单点击方法
    navigateTo(menu) {
      const routeMap = {
        'dashboard': { name: 'AdminDashboard' },
        'employees': { name: 'AdminEmployees' },
        'knowledge': { name: 'AdminKnowledge' },
        'imagelibrary': { name: 'ImageLibrary' },
        'operationlog': { name: 'AdminOperationLog' },
        'statisticsCenter': { name: 'StatisticsCenter' },
        'plan-and-package': { name: 'PlanAndPackage' },
        'cart': { name: 'Cart' },
        'orders': { name: 'orders' },
        'messages': { name: 'messages' },
        'account_setting': { name: 'accountSetting' }
      }
      
      if (routeMap[menu]) {
        this.$router.push(routeMap[menu])
      }
    },
    
    // 处理知识库文档跳转（从子组件调用）
    navigateToDocument(workspaceSlug, workspaceName) {
      this.$router.push({
        name: 'KnowledgeWorkspace',
        params: { workspaceSlug },
        query: { workspaceName }
      })
    },    
  // 修改checkAuth方法
  async checkAuth() {
    console.log(!this.tenantInfo)
    if (!this.tenantInfo) {
      this.$router.push('/login')
      return
    }

    if (this.tenantInfo) {
      this.isDataLoaded = true
    } else {
      setTimeout(() => {
        if (!this.tenantInfo) {
          // 再次尝试刷新
          this.checkTokenAndRefresh().then(success => {
            if (!success || !this.tenantInfo) {
              this.$router.push('/login')
            } else {
              this.isDataLoaded = true
            }
          })
        } else {
          this.isDataLoaded = true
        }
      }, 500)
    }
  },
    validatePhone(phone) {
      this.isPhoneValid = /^1[3-9]\d{9}$/.test(phone)
      if (!this.isPhoneValid) {
        this.$message.error('请输入正确的手机号')
      }
      return this.isPhoneValid
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    },
    checkCountdown() {
    console.log('checkCountdown');
    const savedTime = localStorage.getItem('smsCountdown');
    console.log(savedTime);
    if (savedTime) {
      const remainingTime = Math.ceil((parseInt(savedTime) - Date.now()) / 1000);
      if (remainingTime > 0) {
        this.countdown = remainingTime;
        this.startCountdown();
      } else {
        localStorage.removeItem('smsCountdown');
      }
    }
    },
    closeDropdown() {
      this.isDropdownOpen = false
    },
    // 密码复杂度校验
  validatePassword(pwd) {
    if (!pwd) {
      this.$message.error('请输入密码');
      return false;
    }

    if (pwd.length < this.passwordRules.minLength) {
      this.$message.error(`密码至少需要${this.passwordRules.minLength}位`);
      return false;
    }

    if (pwd.length > this.passwordRules.maxLength) {
      this.$message.error(`密码最长${this.passwordRules.maxLength}位`);
      return false;
    }

    if (this.passwordRules.requireLetter && !/[a-zA-Z]/.test(pwd)) {
      this.$message.error('密码需包含字母');
      return false;
    }

    if (this.passwordRules.requireNumber && !/\d/.test(pwd)) {
      this.$message.error('密码需包含数字');
      return false;
    }
    return true;
  },
    logoutConfirm() {
      this.dialogLogoutVisible = true
      this.closeDropdown()
    },
    deregistrationApply(){
      this.dialogDeregistrationApllyVisible = true
      this.closeDropdown()
    },
    handleLogoutDialogClose() {
      this.dialogLogoutVisible = false
    },

    HandleDelregistrationApplyClose(){
      this.dialogDeregistrationApllyVisible = false
    },
    AccountSettings() {
      this.closeDropdown();
      this.navigateTo('account_setting');
    },
    passwordSetting_sms() {
      this.closeDropdown()
      this.passwordSettings_smsForm.username = this.userInfo.username;
      this.dialogPasswordSettings_smsVisible = true
    },
    ChangePassword(){
      this.closeDropdown()
      this.changePasswordForm.username = this.userInfo.username;
      this.dialogChangePasswordVisible = true
    },
    deregistrationFeedback(){
      this.closeDropdown()
      this.ArchiveFileDownloadVisible = false;
    },
    change_admin(){
      this.closeDropdown()
      console.log('change_admin',this.userInfo);
      this.changeAdminForm.username = this.userInfo.username;
      this.dialogChangeAdminVisible = true
    },
    triggerFileInput() {
      console.log(this.accountSettingsForm.logoFile)
      if (this.accountSettingsForm.logoFile==null) {
        this.$refs.logoFile.click();
      }
    },
    handleAccountSettingsDialogClose() {
      this.dialogAccountSettingsVisible = false
    },
    handlePasswordSettings_smsDialogClose() {
      this.dialogPasswordSettings_smsVisible = false
    },
    handleChangePasswordDialogClose() {
      this.dialogChangePasswordVisible = false
    },
    HandlederegistrationFeedback(){
      this.closeDropdown();
      this.ArchiveFileDownloadVisible = true;
    },
    HandlederegistrationRestoreApply(){
       this.closeDropdown();
       this.deregistrationRestoreApplyVisible = true;
    },
    handleChangeAdminDialogClose() {
      this.dialogChangeAdminVisible = false
    },
    async logout() {
      try {
        // 调用 Vuex 中的 logout action
        await this.$store.dispatch('auth/logout')
        // 退出成功后跳转到登录页
        this.$router.push('/login')
      } catch (error) {
        console.error('退出登录失败:', error)
        // 即使退出API调用失败，也强制清除本地状态并跳转
        this.$store.commit('auth/CLEAR_AUTH')
        this.$router.push('/login')
      }
    },
    // 上传logo
    isImageFile(file) {
      return file && file.type.match('image.*')
    },
    handleFileUpload(event) {
      const file = event.target.files[0]
      if (file) {
        // Validate file size (max 5MB)
        if (file.size > 5 * 1024 * 1024) {
          this.$message.error('文件大小不能超过5MB')
          return
        }

        this.accountSettingsForm.logoFile = file

        if (this.isImageFile(file)) {
          const reader = new FileReader()
          reader.onload = (e) => {
            this.previewImage = e.target.result
          }
          reader.readAsDataURL(file)
        } else {
          this.previewImage = null
        }
      }
    },
    removeFile() {
      this.accountSettingsForm.logoFile = null
      this.previewImage = null
      this.$refs.logoFile.value = ''
    },
    async handlePasswordSettings_smsSubmit() {
      if (this.passwordSettings_smsForm.code=== ''){
        this.$message.error('请输入验证码');
        return;
      }
      if(!this.validatePassword(this.passwordSettings_smsForm.password)){
        return;
      }
      if (this.confirmPassword==='' || this.confirmPassword===null ||this.confirmPassword== undefined) {
        this.$message.error('两次输入的密码不一致');
        return;
      }
      if (this.passwordSettings_smsForm.password !== this.confirmPassword) {
        this.$message.error('两次输入的密码不一致');
        return;
      }

      set_password_sms(this.passwordSettings_smsForm).then(response => {
      console.log('set_password_sms response', response);
      if (response && response.code === 200) {
        this.$message.success('设置密码成功');
        this.dialogPasswordSettings_smsVisible = false;
      }
      else {
        this.$message.error('设置密码失败');
        return
      }
    }).catch(error => {
      console.error('set_password_sms error', error);
      this.$message.error('设置密码失败'+error);
    });
    },
    async handleChangePasswordSubmit() {
      if(this.changePasswordForm.oldPassword===""){
        this.$message.error('原密码不能为空');
        return;
      }
      if(!this.validatePassword(this.changePasswordForm.newPassword)){
        return;
      }
      console.log('changePasswordForm', this.changePasswordForm);
      if (this.changePasswordForm.newPassword !== this.confirmPassword) {
        this.$message.error('两次输入的密码不一致');
        return;
      }

      change_password(this.changePasswordForm).then(response => {
        console.log('change_password response', response);
        if (response && response.code === 200) {
          this.$message.success('修改密码成功');
          this.dialogChangePasswordVisible = false; // 关闭对话框
        } else {
          this.$message.error('修改密码失败');
        }
      }).catch(error => {
        console.error('change_password error', error);
        this.$message.error('修改密码失败'+error);
      });
    },
    async handleAccountSettingsSubmit() {
      if(this.accountSettingsForm.nickName===""){
        this.$message.error('企业简称不能为空');
        return;
      }
      console.log("企业信息:", this.tenantInfo);
      console.log("用户信息:", this.userInfo);
      this.loading_register = true;
      let response = null
      try {
        const formData = new FormData();
        let tenantId = this.tenantInfo?.tenantId;
        formData.append('tenantId', tenantId);
        formData.append('nickName', this.accountSettingsForm?.nickName);
        formData.append('contactPhone', this.userInfo.username);
        // 添加文件
        if (this.accountSettingsForm.logoFile) {
          formData.append('logoFile', this.accountSettingsForm?.logoFile);
        }
        console.log("使用的企业ID:", tenantId);
        response = await postBrief(formData);
        console.log("saveBrief response:",response);

        if (response && response.data && response.data.code === 200) {
          this.dialogAccountSettingsVisible = false;
          this.$message.success("提交成功");
          this.tenantInfo.nickname = this.accountSettingsForm.nickName;
          if (this.accountSettingsForm.logoFile) {
            this.tenantInfo.logoUrl = response.data.message;
          }

        } else {
          const errorMsg = (response.data && response.data.message) || '提交失败';
          this.$message.error(errorMsg);
        }
      } catch (error) {
        const errorMsg = (response.data && response.data.message) || '注册失败';
        this.$message.error(errorMsg);
      } finally {
        this.loading_register = false;
      }
    },
    async handleChangeAdminSubmit() {
      if(this.changeAdminForm.code1===""){
        this.$message.error('请输入原手机验证码');
        return;
      }
      if(this.changeAdminForm.newPhone===""){
        this.$message.error('请输入新手机号码');
        return;
      }
      if(this.changeAdminForm.newPhone===this.changeAdminForm.username){
        this.$message.error('新手机号码不能与原手机号码相同');

        return;
      }
      if(this.changeAdminForm.code2===""){
        this.$message.error('请输入新手机验证码');
        return;
      }
      if(this.changeAdminForm.newName===""){
        this.$message.error('请输入新姓名');
        return;
      }
      console.log('changeAdminForm', this.changeAdminForm);
      change_admin(this.changeAdminForm).then(response => {
        console.log('change_admin response', response);
        if (response && response.code === 200) {
          this.$message.success('变更管理员成功,当前用户已经不能使用了，需要重新登录');
          this.dialogChangeAdminVisible = false; // 关闭对话框
          this.logout();
        } else {
          this.$message.error('变更管理员失败');
        }
      }).catch(error => {
        console.error('change_admin error', error);
        this.$message.error('变更管理员失败:'+error);
      });
    },
    async sendSMSCode(phone) {
      if (this.isCountingDown || !this.validatePhone(phone)) return;

      try {
        const response = await send_sms_code(phone)
        console.log(response);
        if (response.data &&response.status===200 && response.data.code === 200) {
          this.startCountdown();
          this.$message.success('验证码已发送');
          this.smsError = '';
        } else {
          this.$message.error((response.data && response.data.message) || '发送验证码失败');
        }
      } catch (error) {

        this.$message.error(error);
      }
    },
    startCountdown() {
      this.countdown = 60;
      localStorage.setItem('smsCountdown', Date.now() + 60000); // 存储过期时间

      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }

      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          localStorage.removeItem('smsCountdown');
        }
      }, 1000);
    },
    async sendSMSCode_change_admin() {
      let phone = this.changeAdminForm.username+","+ this.changeAdminForm.newPhone;
      if (this.isCountingDown || !this.validatePhone(this.changeAdminForm.newPhone)) return;

      try {
        const response = await send_sms_code(phone)
        console.log(response);
        if (response.data &&response.status===200 && response.data.code === 200) {
          this.startCountdown();
          this.$message.success('已经给2个手机号发送验证码，请分别填入对应手机号下面的验证码文本框');
          this.smsError = '';
        } else {
          this.$message.error((response.data && response.data.message) || '发送验证码失败');
        }
      } catch (error) {

        this.$message.error(error);
      }
    },
    async show_agreement(){
      this.dialogAgreementVisible = true;
    },
    
    HandlederegistrationRestoreApplyDialog(){
       this.deregistrationRestoreApplyVisible = false;
    },


  // 参照 submitAuthenticationForm()
 async submitDetregistrationRestoredataApply() {
    // 创建FormData
    const formData = new FormData();
    formData.append('apply_id', this.deregistrationRestoreForm.apply_id);
    formData.append('sms_code', this.deregistrationRestoreForm.code);
    formData.append('admin_sername', this.tenantInfo.adminUsername);
    formData.append('reason', this.deregistrationRestoreForm.reason);
    
    // 打印确认
    console.log('FormData内容:');
    for (let pair of formData.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
    } 
    let response = null;
    try{
      response = await postTenantDeregistrationRestoredataApply(formData);
      console.log("postTenantDeregistrationRestoredataApply response:",response);

      if (response && response.data && response.data.code === 200) { //自定义code
        const message = (response.data && response.data.message) || '提交成功';
        this.$message.success(message);
        this.deregistrationRestoreApplyVisible = false;
        }else{
      const errorMsg = (response.data && response.data.message) || '提交失败';
      this.$message.error(errorMsg);          
        }
    } catch (error) {
      const errorMsg = (response.data && response.data.message) || '提交失败';
      this.$message.error(errorMsg);
    } finally {
      this.deregistrationRestoreApplyVisible = false;
    }
  },    
  }
}
</script>

<style scoped lang="scss">
//@import '@/styles/public-theme1.scss';
@import '@/styles/variables.scss';
.admin-main-container {
  font-family: 'Alibaba PuHuiTi', sans-serif;
  min-height: 100vh;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
}

/* 导航栏 */
.admin-nav-bar {
  display: flex;
  justify-content: space-between;  /* 两端对齐 */
  align-items: center;
  padding: 12px 60px;  /* 加大左右padding，让中间空出来 */
  overflow: visible;
  z-index: 9999;
}


/* 左侧 Logo */
.nav-left {
  flex: 0 0 auto;  /* 不伸缩 */
}

/* 中间区域 - 站内信居中 */
.nav-center {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  min-width: 40px;  /* 确保至少有图标宽度 */
  position: relative;  /* 重要：作为下拉菜单的定位参照 */
}

/* 右侧用户操作区 */
.nav-right {
  flex: 0 0 auto;  /* 不伸缩 */
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.1rem;
  color: #057FDB;
  font-weight: 500;
  margin-right: auto;
}

/* 用户操作区 */
.user-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
}

.welcome-text {
  font-size: 0.8rem;
  color: #666;
  white-space: nowrap;    /* 防止换行 */
}

.user-dropdown {
  position: relative;
  display: inline-block;
}

.avatar-group {
  display: flex;
  align-items: center;
  gap: 6px;               /* 减小内部间距 */
  padding: 4px 10px;      /* 减小内边距 */
  background: rgba(5,127,219,0.1);
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s;
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid rgba(5,127,219,0.3);
}

.username {
  font-size: 0.85rem;
  color: #057FDB;
  font-weight: 500;
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-icon-arrow-down {
  font-size: 0.8rem;
  color: #057FDB;
  transition: transform 0.3s;

  &.rotated {
    transform: rotate(180deg);
  }
}

/* 用户下拉菜单 */
.dropdown-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 5px);
  z-index: 10001 !important;  /* 强制提高 */
  background: white;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}
.menu-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  font-size: 0.9rem;
  color: #606266;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f5f7fa;
    color: #057FDB;
  }

  i {
    margin-right: 10px;
    font-size: 1rem;
    color: #057FDB;
  }
}

.menu-divider {
  height: 1px;
  background: #ebeef5;
  margin: 4px 0;
}

.menu-item.logout {
  color: #f56c6c;

  i {
    color: #f56c6c;
  }

  &:hover {
    background: #fef0f0;
  }
}

/* 主内容区 */
.admin-main {
  display: flex;
  flex: 1;
}

.sidebar {
  width: 220px;
  background: white;
  border-right: 1px solid #e6e6e6;
  padding: 20px 0;
  box-shadow: 2px 0 5px rgba(0,0,0,0.02);
  transition: all 0.3s;
}

.sidebar-header {
  padding: 0 20px 20px;
  border-bottom: 1px solid #eee;
  margin-bottom: 15px;
}

.tenant-nickname {
  font-size: 0.8rem;
  color: #666;
  background: #f5f5f5;
  padding: 8px 10px;
  border-radius: 4px;
  word-break: break-all;
  min-width: 10px;
  overflow: hidden;
}

.sidebar-menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar-menu li {
  padding: 12px 25px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #555;
  transition: all 0.2s;
  position: relative;

  i {
    font-size: 1.1rem;
    color: #888;
  }

  &:hover {
    background: #f0f7ff;
    color: #057FDB;

    i {
      color: #057FDB;
    }
  }

  &.active {
    background: #f0f7ff;
    color: #057FDB;
    border-right: 3px solid #057FDB;

    i {
      color: #057FDB;
    }
  }
}

.content {
  flex: 1;
  padding: 6px;
  position: relative;
  
}

/* 响应式设计 */
@media (max-width: 992px) {
  .dashboard-charts {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .sidebar {
    width: 60px;

    span {
      display: none;
    }

    li {
      justify-content: center;
      padding: 12px 0;
    }
  }

  .dashboard-stats {
    flex-direction: column;
  }

 /* 用户操作区域改为相对定位，确保子元素能正确定位 */
.user-actions {
  position: relative;
  display: flex;
  align-items: center;
  gap: 15px;
  float: right;
  /* 新增：防止子元素的绝对定位溢出 */
  z-index: 9000;
}

/* 消息徽章的样式优化 */
.message-badge {
  /* 确保徽章在图标右上角正确显示 */
  .el-badge__content {
    z-index: 100;
  }
}

  .welcome-text {
    display: none;
  }
}

#nickName {
    flex: 1;             // input 占据剩余空间
    padding: 12px 15px;
    border: 1px solid $gray-border;
    border-radius: 6px;
    font-size: 1rem;
    transition: all 0.3s;
    width: 65%;
    background: rgba(240, 244, 249, 0.5);
    margin-left: 20px;

    &:focus {
      border-color: #057FDB;
      box-shadow: 0 0 0 3px rgba(#057FDB, 0.2);
    }
  }

  .upload-container {
    margin-top: 10px;
    width: 100%;
  }

  .file-input {
    display: none;
  }
  .required-asterisk {
    color: #ff4d4f; /* 红色 */
    margin-right: 4px;
  }
  .upload-box {
    display: block;
    width: 100%;
    height: 120px;
    border: 2px dashed $gray-border;
    border-radius: 8px;
    background-color: rgba(240, 244, 249, 0.5);
    cursor: pointer;
    transition: all 0.3s;
    position: relative;
    overflow: hidden;

    &:hover {
      border-color: #057FDB;
      background-color: rgba(#057FDB, 0.05);
    }
  }
  .upload-placeholder {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      color: #909399;
  }

.plus-icon {
    font-size: 32px;
    color: #409EFF;
}

  .upload-text {
    font-size: 14px;
  }

  .file-preview {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 0 20px;
    position: relative;
  }

  .thumbnail {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }


.file-name {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 30px;
}

.remove-btn {
    position: absolute;
    top: 1px;
    right: 1px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #ff4d4f;
    color: white;
    border: none;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;

    &:hover {
      background: #ff7875;
    }
  }
  /* 微动点状背景的额外样式 */
.particle-point {
  position: absolute;
  background: #057FDB;
  border-radius: 50%;
  animation: float 6s infinite ease-in-out;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) scale(1);
    opacity: 0.4;
  }
  50% {
    transform: translateY(-8px) scale(1.05);
    opacity: 0.6;
  }
}

canvas[data-generated] {
  position: absolute;
  top: 0;
  left: 0;
}


.form-group {
  display: flex;          // 使用 flex 布局
  align-items: center;   // 垂直居中
  margin-bottom: 10px;   // 保持原有的底部间距
  margin-left: 0;
  padding-left: 0;

  label {
    flex: 0 0 80px;     // 固定 label 宽度
    margin-bottom: 0;    // 移除原来的底部 margin
    padding-right: 15px; // label 和 input 之间的间距
    text-align: right;   // 文字右对齐（可选）
    font-weight: 500;
    color: #474747;
  }

  input {
    flex: 1;             // input 占据剩余空间
 


  }
}

#sms-code {
  width: 90px;
     padding: 12px 15px;
    border: 1px solid $gray-border;
    border-radius: 6px;
    font-size: 1rem;
    transition: all 0.3s;
    background: rgba(240, 244, 249, 0.5);
  margin-right: 10px;
}

#sms-code:focus {
      border-color: #00b4ff;
      box-shadow: 0 0 0 3px rgba(#00b4ff, 0.2);
    }
.sms-group {
  display: flex;
  align-items: center;
  gap: 10px;

  input {
    flex: 1;
    min-width: 0;
  }

  .sms-btn {
    background: #00b4ff;
    color: white;
    border: none;
    padding: 0 15px;
    height: 44px;
    border-radius: 6px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
    white-space: nowrap;

    &:disabled {
      background: #DDD;
      cursor: not-allowed;
    }

    &:not(:disabled):hover {
      background: darken(#00b4ff, 10%);
    }
  }
}
.link{
  font-size: small;
  color: #00b4ff;
  text-decoration: none;

}
.action-buttons{
  text-align: right;
}

/* 试用版弹框美化样式 */
:deep(.free-version-dialog) {
  border-radius: 10px !important;
  overflow: hidden;
  
  .el-dialog__header {
    display: none !important;
  }
  
  .el-dialog__body {
    padding: 0 !important;
  }
}

.dialog-header {
  background: linear-gradient(135deg, #67C23A 0%, #85CE61 100%);
  padding: 5px 10px;
  text-align: center;
  color: white;
  position: relative;
  overflow: hidden;
}

.icon-container {
  margin-bottom: 12px;
}

.success-icon {
  width: 32px;
  height: 32px;
  filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.1));
}

.dialog-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 6px 0;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.dialog-subtitle {
  font-size: 13px;
  opacity: 0.9;
  margin: 0;
}

.dialog-content {
  padding: 25px 30px;
  background: #fff;
}

.features-list {
  margin-bottom: 20px;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
  padding: 12px;
  border-radius: 8px;
  background: #f8f9fa;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.feature-icon {
  font-size: 20px;
  margin-right: 12px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.feature-text {
  flex: 1;
  
  strong {
    display: block;
    font-size: 14px;
    color: #303133;
    margin-bottom: 3px;
    font-weight: 600;
  }
  
  p {
    font-size: 12px;
    color: #606266;
    margin: 0;
    line-height: 1.4;
  }
}

.action-section {
  text-align: center;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.action-hint {
  font-size: 13px;
  color: #606266;
  margin-bottom: 15px;
}

.action-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
}

:deep(.primary-btn) {
  background: linear-gradient(135deg, #67C23A 0%, #85CE61 100%) !important;
  border: none !important;
  padding: 10px 20px !important;
  border-radius: 6px !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  box-shadow: 0 3px 12px rgba(103, 194, 58, 0.25) !important;
  
  &:hover {
    background: linear-gradient(135deg, #5CB031 0%, #76B94F 100%) !important;
    box-shadow: 0 4px 15px rgba(103, 194, 58, 0.35) !important;
  }
  
  .el-icon-setting {
    margin-right: 6px;
  }
}

:deep(.secondary-btn) {
  padding: 10px 20px !important;
  border-radius: 6px !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  
  &:hover {
    border-color: #67C23A !important;
    color: #67C23A !important;
    background: rgba(103, 194, 58, 0.05) !important;
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  :deep(.free-version-dialog) {
    width: 90% !important;
    max-width: 380px !important;
  }
  
  .dialog-header {
    padding: 15px 20px;
  }
  
  .dialog-content {
    padding: 20px;
  }
  
  .action-buttons {
    flex-direction: column;
    gap: 10px;
  }
  
  :deep(.primary-btn),
  :deep(.secondary-btn) {
    width: 100%;
  }
}

/* 站内信图标容器 */
.message-dropdown {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.message-trigger {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(5,127,219,0.05);
  cursor: pointer;
  transition: all 0.3s;
  
  i {
    font-size: 20px;
    color: #057FDB;
  }
  
  &:hover {
    background: rgba(5,127,219,0.1);
  }
}
/* 站内信下拉菜单 - 绝对定位，不占用文档流空间 */
/* 站内信下拉菜单 - 居中弹出 */
.message-dropdown-menu {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(100% + 5px);
  z-index: 10000 !important;
  background: white;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  min-width: 280px;  /* 增加最小宽度，让菜单可见 */
  white-space: nowrap;
}
/* 站内信下拉菜单 - 居中弹出 */
.message-dropdown-menu {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(100% + 5px);
  z-index: 10000 !important;
  background: white;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.12);
  min-width: 250px;
  padding: 8px 0;
}

/* 菜单头部 */
.message-menu-header {
  padding: 10px 16px 8px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 4px;
}

.message-menu-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

/* 每个菜单项 */
.message-menu-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  cursor: pointer;
  transition: background 0.2s;
  position: relative;
}

.message-menu-item:hover {
  background: #f5f7fa;
}

/* 图标容器 */
.menu-item-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.menu-item-icon i {
  font-size: 18px;
}

.inbox-icon {
  background: rgba(5,127,219,0.1);
  color: #057FDB;
}

.batch-icon {
  background: rgba(103,194,58,0.1);
  color: #67C23A;
}

.feedback-icon {
  background: rgba(230,162,60,0.1);
  color: #E6A23C;
}

.suggest-icon {
  background: rgba(144,147,153,0.1);
  color: #909399;
}

/* 文字信息 */
.menu-item-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.menu-item-label {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.menu-item-desc {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
}

/* 徽章 */
.menu-item-badge {
  margin-left: 8px;
}

/* 分隔线 */
.message-menu-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 4px 16px;
}

::v-deep .custom-select-popper {
  z-index: 3000 !important;
}

.upload-area {
  width: 100%;
  height: 160px;
  border: 2px dashed #dcdfe6;
  border-radius: 8px;
  background-color: rgba(240, 244, 249, 0.5);
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    border-color: #057FDB;
    background-color: rgba(5, 127, 219, 0.05);
  }
}

.upload-area:hover {
    border-color: #409EFF;
    background: #f0f7ff;
}
.preview-area {
  position: relative;
  width: 100%;
  height: 120px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background: white;
}
.custom-textarea {
  resize: none;
  font-size: 14px;
}
.upload-container {
  margin-top: 10px;
  width: 100%;
}
.file-input {
  display: none;
}
input[type="checkbox"]:not(.radio-style-checkbox)  {
  appearance: none;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  border: 1px solid #00b4ff;
  border-radius: 2px;
  outline: none;
  cursor: pointer;
  vertical-align: middle;
  margin-right: 6px;
  position: relative;
  transition: all 0.2s;
}

input[type="checkbox"]:checked {
  background-color: #00b4ff;
  border-color: #00b4ff;
}
input[type="checkbox"]:checked::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 18px;
  font-weight: bold;
}

input[type="checkbox"]:hover {
  border-color: darken(#00b4ff, 10%);
}
.label{
  width: 150px;
  font-family: 微软雅黑;
  font-weight: bold;
  font-size: 12pt;
  text-align: right;
  margin-right: 10px;
}
/* 强制覆盖所有 input[type="checkbox"] 的伪元素 */
input[type="checkbox"].radio-style-checkbox::before,
input[type="checkbox"].radio-style-checkbox::after {
  display: none !important;
  content: none !important;
}

/* 重新定义我们的伪元素 */
input[type="checkbox"].radio-style-checkbox::after {
  content: "" !important;
  display: block !important;
  position: absolute !important;
  left: 50% !important;
  top: 50% !important;
  width: 8px !important;
  height: 8px !important;
  background: #fff !important;
  border-radius: 50% !important;
  transform: translate(-50%, -50%) scale(0) !important;
  transition: transform 0.15s ease-in !important;
  pointer-events: none !important;
  z-index: 1 !important;
}

input[type="checkbox"].radio-style-checkbox:checked {
  background: #409EFF !important;
  border-color: #409EFF !important;
}

input[type="checkbox"].radio-style-checkbox:checked::after {
  transform: translate(-50%, -50%) scale(1) !important;
}
</style>
<style>
/* 建议把圆点样式统一写在全局，避免 scoped 穿透问题 */
input[type="checkbox"].radio-style-checkbox {
  appearance: none !important;
  -webkit-appearance: none !important;
  width: 18px !important;
  height: 18px !important;
  border: 1px solid #409EFF !important;
  border-radius: 50% !important;
  background: #fff !important;
  position: relative !important;
  cursor: pointer !important;
  vertical-align: middle !important;
  margin-right: 6px !important;
  box-sizing: border-box !important;
  flex-shrink: 0 !important;
}

input[type="checkbox"].radio-style-checkbox:checked {
  background: #409EFF !important;
  border-color: #409EFF !important;
}

input[type="checkbox"].radio-style-checkbox:checked::after {
  content: "" !important;
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  width: 8px !important;
  height: 8px !important;
  background: #fff !important;
  border-radius: 50% !important;
  display: block !important;
}
</style>
